import { Component, ElementRef, ViewChild, ViewChildren, QueryList, OnInit, Output, EventEmitter, OnDestroy, Input } from '@angular/core';
import { NgForm, NgModel } from '@angular/forms';
import { debounceTime, distinctUntilChanged, map, take } from 'rxjs/operators';
import { Subscription } from 'rxjs';

import { ApiError, ConfigService, FormsUtilsService, MessageService, notCloseMessageOptions } from '../../../../core';
import { KPI_RAP, KPI_CUSTOMER_SHARE } from '../../../kpis';
import { ConfigAnaliseMercado } from '../../../configuracoes/app/analise-mercado';
import { ConfigCliente } from '../../../configuracoes/app/cliente';
import { Decimal2Component, MesPipe } from '../../../../shared';
import { lancamentoQuantidade, isLancamentoQuantidade, lancamentoPeso, isLancamentoPeso, lancamentoValor, isLancamentoValor } from '../../../../models';
import { isPerspectivaRAP, isPerspectivaClassificacao } from '../../perspectivas/cliente-analise-mercado-perspectiva';
import { CLIENTE_ANALISE_MERCADO_PERIODICIDADE_ANUAL, isClienteAnaliseMercadoPeriodicidadeAnual, CLIENTE_ANALISE_MERCADO_PERIODICIDADE_MEDIA_MENSAL, isClienteAnaliseMercadoPeriodicidadeMediaMensal, CLIENTE_ANALISE_MERCADO_PERIODICIDADE_MENSAL, isClienteAnaliseMercadoPeriodicidadeMensal } from '../../domain';
import { ClienteAnaliseMercadoLancamento } from '../cliente-analise-mercado-lancamento';
import { ClienteAnaliseMercadoLancamentoMes } from '../cliente-analise-mercado-lancamento-mes';
import { ClienteAnaliseMercadoLancamentoSave } from '../cliente-analise-mercado-lancamento-save';
import { ClienteAnaliseMercadoLancamentoHttpService, ClienteAnaliseMercadoLancamentoMesCalculoService } from '../services';
import { calcularValorPotencial } from '../../calculo/potencial';
import { calcularParticipacaoQuantidadePretendida, calcularQuantidadePretendidaPerc, calcularParticipacaoPesoPretendido, calcularPesoPretendidoPerc, calcularParticipacaoValorPretendido, calcularValorPretendido, calcularValorPretendidoPerc } from '../../calculo/pretendido';
import { calcularQuantidadeProjetadaPerc, calcularPesoProjetadoPerc, calcularValorProjetado, calcularValorProjetadoPerc } from '../../calculo/projetado';
import { calcularQuantidadeRealizadaPerc, calcularPesoRealizadoPerc, calcularValorRealizadoPerc } from '../../calculo/realizado';
import { calcularQuantidadeAnual, calcularPesoAnual, calcularValorAnual } from '../../calculo/anual';
import { calcularQuantidadeMediaMensal, calcularPesoMedioMensal, calcularValorMedioMensal } from '../../calculo/media-mensal';
import { calcularPercEvolucao } from '../../calculo/evolucao';
import { ClienteAnaliseMercadoStatusPretendidoService } from '../../status-pretendido';
import { ClienteAnaliseMercadoStatusProjetadoService } from '../../status-projetado';
import { ClassificacaoFaturamento, ClassificacaoFaturamentoCrudHttpService, ClassificacaoFaturamentoAnualHttpService } from '../../../classificacao-faturamento';
import { CustomerShareValueObject } from '../../../pic/customer-share';


interface Config {
    isPerspectivaRAP: boolean;
    isPerspectivaClassificacao: boolean;
}

@Component({
    selector: 'sgt-cliente-analise-mercado-lancamento-form',
    templateUrl: './cliente-analise-mercado-lancamento-form.component.html',
    styleUrls: ['./cliente-analise-mercado-lancamento-form.component.less']
})
export class ClienteAnaliseMercadoLancamentoFormComponent implements OnInit, OnDestroy {
    config: Config;
    configCliente: ConfigCliente;
    configAnaliseMercado: ConfigAnaliseMercado;

    perspectiva: number;
    entityLancamento: ClienteAnaliseMercadoLancamento;
    /** Se pode editar o form */
    @Input() canEdit = true;
    isLoading: boolean;
    @Output() isLoadingChange = new EventEmitter<boolean>();

    // KPIs
    KPI_RAP = KPI_RAP;
    KPI_CUSTOMER_SHARE = KPI_CUSTOMER_SHARE;

    // Configs.
    /** Se deve exibir as colunas do projetado */
    showProjetado = true;

    // Table colspan Quantidade
    tableColspanQuantidade: number;
    tableColspanQuantidadeAnoAnterior1: number;
    tableColspanQuantidadeAno: number;
    // Table colspan Peso
    tableColspanPeso: number;
    tableColspanPesoAnoAnterior1: number;
    tableColspanPesoAno: number;
    // Table colspan Valor
    tableColspanValor: number;
    tableColspanValorAnoAnterior1: number;
    tableColspanValorAno: number;

    // Lançamentos
    lancamentoQuantidade = lancamentoQuantidade;
    lancamentoPeso = lancamentoPeso;
    lancamentoValor = lancamentoValor;

    // Periodicidades
    periodicidadeAnual = CLIENTE_ANALISE_MERCADO_PERIODICIDADE_ANUAL;
    periodicidadeMediaMensal = CLIENTE_ANALISE_MERCADO_PERIODICIDADE_MEDIA_MENSAL;
    periodicidadeMensal = CLIENTE_ANALISE_MERCADO_PERIODICIDADE_MENSAL;

    classificacoesRAP: ClassificacaoFaturamento[];

    @ViewChild('form') form: NgForm;
    @ViewChild('btnSave') btnSave: ElementRef;
    /** tbody mensal da table */
    @ViewChild('tbodyMensal') tbodyMensal: ElementRef;
    @ViewChildren(Decimal2Component) decimalComponents: QueryList<Decimal2Component>;
    // Valor Unitário por Quantidade
    @ViewChild('quantidadePretendidaValorUnitarioDecimalAnual') quantidadePretendidaValorUnitarioDecimalAnual: Decimal2Component;
    @ViewChild('quantidadePretendidaValorUnitarioDecimalMediaMensal') quantidadePretendidaValorUnitarioDecimalMediaMensal: Decimal2Component;
    @ViewChildren('quantidadePretetendidaValorUnitarioDecimalMes') quantidadePretetendidaValorUnitarioDecimalMeses: QueryList<Decimal2Component>;
    // Valor Unitário por Peso
    @ViewChild('pesoPretendidoValorUnitarioDecimalAnual') pesoPretendidoValorUnitarioDecimalAnual: Decimal2Component;
    @ViewChild('pesoPretendidoValorUnitarioDecimalMediaMensal') pesoPretendidoValorUnitarioDecimalMediaMensal: Decimal2Component;
    @ViewChildren('pesoPretendidoValorUnitarioDecimalMes') pesoPretendidoValorUnitarioDecimalMeses: QueryList<Decimal2Component>;
    // Valor Pretendido Anual
    @ViewChild('valorPretendidoAnual') valorPretendidoAnual: NgModel;
    valorPretendidoAnualSubscription: Subscription;

    constructor(private configService: ConfigService,
                private formsUtilsService: FormsUtilsService,
                private messageService: MessageService,
                private mesPipe: MesPipe,
                private clienteAnaliseMercadoLancamentoHttpService: ClienteAnaliseMercadoLancamentoHttpService,
                private clienteAnaliseMercadoLancamentoMesCalculoService: ClienteAnaliseMercadoLancamentoMesCalculoService,
                private clienteAnaliseMercadoStatusPretendidoService: ClienteAnaliseMercadoStatusPretendidoService,
                private clienteAnaliseMercadoStatusProjetadoService: ClienteAnaliseMercadoStatusProjetadoService,
                private classificacaoFaturamentoCrudHttpService: ClassificacaoFaturamentoCrudHttpService,
                private classificacaoFaturamentoAnualHttpService: ClassificacaoFaturamentoAnualHttpService) { }

    ngOnInit() {
        this.configAnaliseMercado = this.configService.getAnaliseMercado();
        this.configCliente = this.configService.getCliente();
    }

    private setConfig() {
        this.config = {
            isPerspectivaRAP: isPerspectivaRAP(this.perspectiva),
            isPerspectivaClassificacao: isPerspectivaClassificacao(this.perspectiva)
        };
    }

    private setLoading(value: boolean) {
        this.isLoading = value;
        this.isLoadingChange.emit(this.isLoading);
    }

    /** Carrega o lançamento da análise de mercado */
    load(perspectiva: number, idCliente: number, ano: number, idClienteAnaliseMercadoClassificacao: number, idGrupoClassificacao: number, idsClassificacoes: number[], criarSeNaoEncontrar: boolean): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.setLoading(true);
            this.perspectiva = perspectiva;
            this.entityLancamento = null;

            this.clienteAnaliseMercadoLancamentoHttpService.load(perspectiva, idCliente, ano, idClienteAnaliseMercadoClassificacao, idGrupoClassificacao, idsClassificacoes, criarSeNaoEncontrar)
                .pipe(
                    take(1)
                )
                .subscribe(
                    entityLancamento => {
                        this.entityLancamento = entityLancamento;
                        this.afterLoad();
                        setTimeout(() => this.setFocusFirstDecimalComponent(), 300);
                        resolve();
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao carregar o lançamento da análise de mercado', error);
                        this.setLoading(false);
                        reject();
                    }
                );
        });
    }

    private afterLoad() {
        this.setConfig();
        this.calcularTableColspans();
        this.setLoading(false);
        this.searchClassificacoesRAP();
        setTimeout(() => this.subscribeToValorPretendidoAnual(), 1000);
    }

    /** Seta o foco no primeiro decimal component habilitado */
    private setFocusFirstDecimalComponent() {
        const decimalComponent = this.decimalComponents.find(dc => dc.disabled === false);
        decimalComponent?.setFocus();
    }

    /** Verifica se o lançamento da análise é por quantidade */
    isLancamentoQuantidade(): boolean {
        return isLancamentoQuantidade(this.entityLancamento?.lancamento);
    }

    /** Verifica se o lançamento da análise é por peso */
    isLancamentoPeso(): boolean {
        return isLancamentoPeso(this.entityLancamento?.lancamento);
    }

    /** Verifica se o lançamento da análise é por valor */
    isLancamentoValor(): boolean {
        return isLancamentoValor(this.entityLancamento?.lancamento);
    }

    /** Ao selecionar a opção de lançamento da análise */
    onSelectLancamento() {
        this.calcularTableColspans();
    }

    /** Verifica se a periodicidade da análise é Anual */
    isPeriodicidadeAnual(): boolean {
        return isClienteAnaliseMercadoPeriodicidadeAnual(this.entityLancamento?.periodicidade);
    }

    /** Verifica se a periodicidade da análise é Média Mensal */
    isPeriodicidadeMediaMensal(): boolean {
        return isClienteAnaliseMercadoPeriodicidadeMediaMensal(this.entityLancamento?.periodicidade);
    }

    /** Verifica se a periodicidade da análise é Mensal */
    isPeriodicidadeMensal(): boolean {
        return isClienteAnaliseMercadoPeriodicidadeMensal(this.entityLancamento?.periodicidade);
    }

    /** Colspans do agrupamento do head da quantidade na table */
    private calcularTableColspanQuantidade(): number {
        let colspan = 0;

        // Quantidade realizada ano anterior 2
        colspan += 1;
        // Quantidade realizada ano anterior 1
        colspan += 1;
        // Quantidade pretendida ano anterior 1
        colspan += this.isLancamentoQuantidade() ? 1 : 0;
        // Valor Unitário
        colspan += (this.isLancamentoQuantidade() && this.entityLancamento?.solicitarPrecoMedio) ? 1 : 0;
        // Quantidade potencial
        colspan += (this.isLancamentoQuantidade() && this.configAnaliseMercado?.solicitarPotencial) ? 1 : 0;
        // Quantidade pretendida
        colspan += this.isLancamentoQuantidade() ? 1 : 0;
        // Valor Unitário Projetado
        colspan += (this.showProjetado && this.isLancamentoQuantidade() && this.entityLancamento?.solicitarPrecoMedio) ? 1 : 0;
        // Quantidade projetada
        colspan += (this.showProjetado && this.isLancamentoQuantidade()) ? 1 : 0;
        // Quantidade realizada
        colspan += 1;
        // Perc. Evolução
        colspan += this.isLancamentoQuantidade() ? 1 : 0;

        return colspan;
    }
    /** Colspans do agrupamento do ano anterior 1 do head da quantidade na table */
    private calcularTableColspanQuantidadeAnoAnterior1(): number {
        let colspan = 0;
        // Quantidade pretendida ano anterior 1
        colspan += this.isLancamentoQuantidade() ? 1 : 0;
        // Quantidade realizada ano anterior 1
        colspan += 1;

        return colspan;
    }
    /** Colspans do agrupamento do ano do head da quantidade na table */
    private calcularTableColspanQuantidadeAno(): number {
        let colspan = 0;

        // Valor Unitário
        colspan += (this.isLancamentoQuantidade() && this.entityLancamento?.solicitarPrecoMedio) ? 1 : 0;
        // Quantidade potencial
        colspan += (this.isLancamentoQuantidade() && this.configAnaliseMercado?.solicitarPotencial) ? 1 : 0;
        // Quantidade pretendida
        colspan += this.isLancamentoQuantidade() ? 1 : 0;
        // Valor Unitário Projetado
        colspan += (this.showProjetado && this.isLancamentoQuantidade() && this.entityLancamento?.solicitarPrecoMedio) ? 1 : 0;
        // Quantidade projetada
        colspan += (this.showProjetado && this.isLancamentoQuantidade()) ? 1 : 0;
        // Quantidade realizada
        colspan += 1;
        // Perc. Evolução
        colspan += this.isLancamentoQuantidade() ? 1 : 0;

        return colspan;
    }

    /** Colspans do head do peso na table */
    private calcularTableColspanPeso(): number {
        let colspan = 0;

        // Peso realizado ano anterior 2
        colspan += 1;
        // Peso realizado ano anterior 1
        colspan += 1;
        // Peso pretendido ano anterior 1
        colspan += this.isLancamentoPeso() ? 1 : 0;
        // Valor Unitário
        colspan += (this.isLancamentoPeso() && this.entityLancamento?.solicitarPrecoMedio) ? 1 : 0;
        // Peso potencial
        colspan += (this.isLancamentoPeso() && this.configAnaliseMercado?.solicitarPotencial) ? 1 : 0;
        // Peso pretendido
        colspan += this.isLancamentoPeso() ? 1 : 0;
        // Valor Unitário Projetado
        colspan += (this.showProjetado && this.isLancamentoPeso() && this.entityLancamento?.solicitarPrecoMedio) ? 1 : 0;
        // Peso projetado
        colspan += (this.showProjetado && this.isLancamentoPeso()) ? 1 : 0;
        // Peso realizado
        colspan += 1;
        // Perc. Evolução
        colspan += this.isLancamentoPeso() ? 1 : 0;

        return colspan;
    }
    /** Colspans do agrupamento do ano anterior 1 do head do peso na table */
    private calcularTableColspanPesoAnoAnterior1(): number {
        let colspan = 0;
        // Peso pretendido ano anterior 1
        colspan += this.isLancamentoPeso() ? 1 : 0;
        // Peso realizado ano anterior 1
        colspan += 1;

        return colspan;
    }
    /** Colspans do agrupamento do ano do head do peso na table */
    private calcularTableColspanPesoAno(): number {
        let colspan = 0;
        // Valor Unitário
        colspan += (this.isLancamentoPeso() && this.entityLancamento?.solicitarPrecoMedio) ? 1 : 0;
        // Peso potencial
        colspan += (this.isLancamentoPeso() && this.configAnaliseMercado?.solicitarPotencial) ? 1 : 0;
        // Peso pretendido
        colspan += this.isLancamentoPeso() ? 1 : 0;
        // Valor Unitário Projetado
        colspan += (this.showProjetado && this.isLancamentoPeso() && this.entityLancamento?.solicitarPrecoMedio) ? 1 : 0;
        // Peso projetado
        colspan += (this.showProjetado && this.isLancamentoPeso()) ? 1 : 0;
        // Peso realizado
        colspan += 1;
        // Perc. Evolução
        colspan += this.isLancamentoPeso() ? 1 : 0;

        return colspan;
    }

    /** Colspans do head do valor na table */
    private calcularTableColspanValor(): number {
        let colspan = 0;

        // Valor realizado ano anterior 2
        colspan += 1;
        // Valor pretendido ano anterior 1
        colspan += 1;
        // Valor realizado ano anterior 1
        colspan += 1;
        // Valor potencial
        colspan += (this.configAnaliseMercado?.solicitarPotencial && this.isLancamentoValor()) ? 1 : 0;
        // Valor pretendido
        colspan += 1;
        // Customer Share
        colspan += 1;
        // Valor projetado
        colspan += this.showProjetado ? 1 : 0;
        // Valor realizado
        colspan += 1;
        // Perc. Evolução
        colspan += this.isLancamentoValor() ? 1 : 0;

        return colspan;
    }
    /** Colspans do agrupamento do ano anterior 1 do head do valor na table */
    private calcularTableColspanValorAnoAnterior1(): number {
        let colspan = 0;
        // Valor pretendido ano anterior 1
        colspan += 1;
        // Valor realizado ano anterior 1
        colspan += 1;

        return colspan;
    }
    /** Colspans do agrupamento do ano do head do valor na table */
    private calcularTableColspanValorAno(): number {
        let colspan = 0;
        // Valor potencial
        colspan += (this.configAnaliseMercado?.solicitarPotencial && this.isLancamentoValor()) ? 1 : 0;
        // Valor pretendido
        colspan += 1;
        // Customer Share
        colspan += 1;
        // Valor projetado
        colspan += this.showProjetado ? 1 : 0;
        // Valor realizado
        colspan += 1;
        // Perc. Evolução
        colspan += this.isLancamentoValor() ? 1 : 0;

        return colspan;
    }


    private calcularTableColspans() {
        // Quantidade
        this.tableColspanQuantidade = this.calcularTableColspanQuantidade();
        this.tableColspanQuantidadeAnoAnterior1 = this.calcularTableColspanQuantidadeAnoAnterior1();
        this.tableColspanQuantidadeAno = this.calcularTableColspanQuantidadeAno();
        // Peso
        this.tableColspanPeso = this.calcularTableColspanPeso();
        this.tableColspanPesoAnoAnterior1 = this.calcularTableColspanPesoAnoAnterior1();
        this.tableColspanPesoAno = this.calcularTableColspanPesoAno();
        // Valor
        this.tableColspanValor = this.calcularTableColspanValor();
        this.tableColspanValorAnoAnterior1 = this.calcularTableColspanValorAnoAnterior1();
        this.tableColspanValorAno = this.calcularTableColspanValorAno();
    }

    /** Anual */

    /** Pesquisa as Classificações RAP (Classificações de Faturamento) */
    private searchClassificacoesRAP() {
        this.classificacoesRAP = [];
        if (!this.config.isPerspectivaRAP) {
            return;
        }

        this.classificacaoFaturamentoCrudHttpService.search()
            .pipe(
                take(1)
            )
            .subscribe(
                classificacoesRAP => this.classificacoesRAP = classificacoesRAP,
                (error: ApiError) => this.messageService.error(error.cause, error.message, error)
            );
    }

    /** Obtem a Classificação RAP através do valor de faturamento anual */
    private findClassificacaoRAPByValorFaturamentoAnual(valorFaturamentoAnual: number): Promise<ClassificacaoFaturamento> {
        return new Promise<ClassificacaoFaturamento>((resolve, reject) => {
            this.classificacaoFaturamentoAnualHttpService.findByValorFaturamentoAnual(valorFaturamentoAnual)
                .pipe(
                    take(1)
                )
                .subscribe(
                    classificacaoRAP => resolve(classificacaoRAP),
                    (error: ApiError) => {
                        this.messageService.error(error.cause, `Erro ao tentar obter a Classificação ${this.KPI_RAP.sigla}`, error);
                        reject(error);
                    }
                );
        });
    }

    /** Seta a Classificação RAP no lançamento */
    private setClassificacaoRAP(classificacaoRAP: ClassificacaoFaturamento) {
        this.entityLancamento.idClassificacaoRAP = classificacaoRAP?.id ?? null;
        this.entityLancamento.nomeClassificacaoRAP = classificacaoRAP?.nome ?? null;
    }

    /** Ao alterar a Classificação RAP */
    onChangeClassificacaoRAP(idClassificacaoRAP: number) {
        // Obtendo e setando a Classificação RAP selecionada no lançamento
        const classificacaoRAP = this.classificacoesRAP.find(classificacaoRAPFilter => classificacaoRAPFilter.id === idClassificacaoRAP);
        this.setClassificacaoRAP(classificacaoRAP);

        // Setando o valor pretendido anual com o Valor Padrão do RAP da Classificação selecionada
        this.onChangeValorPretendidoAnual(classificacaoRAP?.valorPadraoRAP ?? 0, true);
    }

    /** Verifica se pode editar o lançamento por quantidade e periodicidade anual */
    canEditLancamentoQuantidadeAnual(): boolean {
        // Se puder editar e o lançamento for por quantidade e a periodicidade for anual
        return this.canEdit && this.isLancamentoQuantidade() && this.isPeriodicidadeAnual();
    }

    /** Verifica se pode editar o lançamento por peso e periodicidade anual */
    canEditLancamentoPesoAnual(): boolean {
        // Se puder editar e o lançamento for por peso e a periodicidade for anual
        return this.canEdit && this.isLancamentoPeso() && this.isPeriodicidadeAnual();
    }

    /** Verifica se pode editar o lançamento por valor e periodicidade anual */
    canEditLancamentoValorAnual(): boolean {
        // Se puder editar e o lançamento for por valor e a periodicidade for anual
        return this.canEdit && this.isLancamentoValor() && this.isPeriodicidadeAnual();
    }

    /** Ao selecionar a periodicidade anual */
    onSelectPeriodicidadeAnual() {
        /** Removendo os valores unitários anuais para ter que informar um novo valor */
        // Quantidade
        this.entityLancamento.quantidadePretendidaValorUnitario = null;
        this.entityLancamento.quantidadeProjetadaValorUnitario = null;
        // Peso
        this.entityLancamento.pesoPretendidoValorUnitario = null;
        this.entityLancamento.pesoProjetadoValorUnitario = null;
    }

    /** Verifica se o valor unitário é obrigatório ser informado no ano quando o lançamento for por quantidade */
    isQuantidadePretendidaValorUnitarioAnualRequired(): boolean {
        // Se o lançamento não for por quantidade então não é obrigatório
        if (!this.isLancamentoQuantidade()) {
            return false;
        }
        // Se não solicitar o preço médio então não é obrigatório
        if (!this.entityLancamento?.solicitarPrecoMedio) {
            return false;
        }
        // Se não for a periodicidade anual, então não é obrigatório
        if (!this.isPeriodicidadeAnual()) {
            return false;
        }

        // Se possuir a quantidade potencial informada é obrigatório
        if ( (this.configAnaliseMercado?.solicitarPotencial) && (this.entityLancamento.quantidadePotencial !== null && this.entityLancamento.quantidadePotencial !== undefined) ) {
            return true;
        }
        // Se possuir a quantidade pretendida informada é obrigatório
        if (this.entityLancamento.quantidadePretendida !== null && this.entityLancamento.quantidadePretendida !== undefined) {
            return true;
        }

        return false;
    }

    /** Ao alterar o valor unitário anual quando o lançamento for por quantidade */
    onChangeQuantidadePretendidaValorUnitarioAnual(quantidadePretendidaValorUnitario: number) {
        // Setando o valor unitário pretendido
        this.entityLancamento.quantidadePretendidaValorUnitario = quantidadePretendidaValorUnitario;

        // Setando o valor unitário nos 12 meses
        this.setQuantidadePretendidaValorUnitarioMeses(this.entityLancamento.quantidadePretendidaValorUnitario);

        // Setando o valor unitário projetado igual ao valor unitário pretendido
        this.onChangeQuantidadeProjetadaValorUnitarioAnual(this.entityLancamento.quantidadePretendidaValorUnitario);
    }

    /** Ao alterar o valor unitário projetado anual quando o lançamento for por quantidade */
    private onChangeQuantidadeProjetadaValorUnitarioAnual(quantidadeProjetadaValorUnitario: number) {
        this.entityLancamento.quantidadeProjetadaValorUnitario = quantidadeProjetadaValorUnitario;

        // Setando o valor unitário projetado nos 12 meses
        this.setQuantidadeProjetadaValorUnitarioMeses(this.entityLancamento.quantidadeProjetadaValorUnitario);
    }

    /** Verifica se o valor unitário é obrigatório ser informado no ano quando o lançamento for por peso */
    isPesoPretendidoValorUnitarioAnualRequired(): boolean {
        // Se lançamento não for por peso então não é obrigatório
        if (!this.isLancamentoPeso()) {
            return false;
        }
        // Se não solicitar o preço médio então não é obrigatório
        if (!this.entityLancamento?.solicitarPrecoMedio) {
            return false;
        }
        // Se não for a periodicidade anual, então não é obrigatório
        if (!this.isPeriodicidadeAnual()) {
            return false;
        }

        // Se possuir o peso potencial informado é obrigatório
        if ( (this.configAnaliseMercado?.solicitarPotencial) && (this.entityLancamento.pesoPotencial !== null && this.entityLancamento.pesoPotencial !== undefined) ) {
            return true;
        }
        // Se possuir o peso pretendido informado é obrigatório
        if (this.entityLancamento.pesoPretendido !== null && this.entityLancamento.pesoPretendido !== undefined) {
            return true;
        }

        return false;
    }

    /** Ao alterar o valor unitário anual quando o lançamento for por peso */
    onChangePesoPretendidoValorUnitarioAnual(pesoPretendidoValorUnitario: number) {
        // Setando o valor unitário pretendido
        this.entityLancamento.pesoPretendidoValorUnitario = pesoPretendidoValorUnitario;

        // Setando o valor unitário nos 12 meses
        this.setPesoPretendidoValorUnitarioMeses(this.entityLancamento.pesoPretendidoValorUnitario);

        // Setando o valor unitário projetado igual ao valor unitário pretendido
        this.onChangePesoProjetadoValorUnitarioAnual(this.entityLancamento.pesoPretendidoValorUnitario);
    }

    /** Ao alterar o valor unitário projetado anual quando o lançamento for por peso */
    private onChangePesoProjetadoValorUnitarioAnual(pesoProjetadoValorUnitario: number) {
        this.entityLancamento.pesoProjetadoValorUnitario = pesoProjetadoValorUnitario;

        // Setando o valor unitário nos 12 meses
        this.setPesoProjetadoValorUnitarioMeses(this.entityLancamento.pesoProjetadoValorUnitario);
    }

    onChangeQuantidadePotencialAnual(quantidadePotencial: number) {
        // Setando a quantidade potencial anual
        this.changeQuantidadePotencialAnual(quantidadePotencial);
        // Setando a quantidade potencial média mensal nos 12 meses
        this.setQuantidadePotencialMediaMensalMeses();
        // Calculando o valor potencial anual
        const valorPotencial = calcularValorPotencial(this.entityLancamento.quantidadePotencial, this.entityLancamento.quantidadePretendidaValorUnitario, 2);
        this.onChangeValorPotencialAnual(valorPotencial);
    }
    private changeQuantidadePotencialAnual(quantidadePotencial: number) {
        this.entityLancamento.quantidadePotencial = quantidadePotencial;
        // Calculando o percentual de participação da quantidade pretendida sobre a quantidade potencial anual
        this.entityLancamento.quantidadePretendidaPerc = calcularQuantidadePretendidaPerc(this.entityLancamento.quantidadePretendida, this.entityLancamento.quantidadePotencial);
        // Calculando o percentual de participação da quantidade projetada sobre a quantidade potencial anual
        this.entityLancamento.quantidadeProjetadaPerc = calcularQuantidadeProjetadaPerc(this.entityLancamento.quantidadeProjetada, this.entityLancamento.quantidadePotencial);
        // Calculando a quantidade potencial média mensal
        this.entityLancamento.quantidadePotencialMediaMensal = calcularQuantidadeMediaMensal(this.entityLancamento.quantidadePotencial);
        // Obtendo o status pretendido
        this.entityLancamento.statusPretendido = this.clienteAnaliseMercadoStatusPretendidoService.getStatusPretendido(this.entityLancamento.quantidadePotencial, this.entityLancamento.pesoPotencial, this.entityLancamento.valorPotencial, this.entityLancamento.quantidadePretendida, this.entityLancamento.pesoPretendido, this.entityLancamento.valorPretendido, this.entityLancamento.quantidadeRealizada, this.entityLancamento.pesoRealizado, this.entityLancamento.valorRealizado);
        // Obtendo o status do lançamento projetado
        // this.entityLancamento.statusProjetado = this.clienteAnaliseMercadoStatusProjetadoService.getStatusProjetado(this.entityLancamento.statusProjetado, this.entityLancamento.quantidadeProjetada, this.entityLancamento.pesoProjetado, this.entityLancamento.valorProjetado, this.entityLancamento.quantidadeRealizada, this.entityLancamento.pesoRealizado, this.entityLancamento.valorRealizado);
    }

    onChangePesoPotencialAnual(pesoPotencial: number) {

        // Setando o peso potencial anual
        this.changePesoPotencialAnual(pesoPotencial);
        // Setando o peso potencial médio mensal nos 12 meses
        this.setPesoPotencialMedioMensalMeses();
        // Calculando o valor potencial anual
        const valorPotencial = calcularValorPotencial(this.entityLancamento.pesoPotencial, this.entityLancamento.pesoPretendidoValorUnitario, 2);
        this.onChangeValorPotencialAnual(valorPotencial);
    }
    private changePesoPotencialAnual(pesoPotencial: number) {
        this.entityLancamento.pesoPotencial = pesoPotencial;
        // Calculando o percentual de participação do pretendida sobre o peso potencial anual
        this.entityLancamento.pesoPretendidoPerc = calcularPesoPretendidoPerc(this.entityLancamento.pesoPretendido, this.entityLancamento.pesoPotencial);
        // Calculando o percentual de participação do peso projetado sobre o peso potencial anual
        this.entityLancamento.pesoProjetadoPerc = calcularPesoProjetadoPerc(this.entityLancamento.pesoProjetado, this.entityLancamento.pesoPotencial);
        // Calculando o peso potencial média mensal
        this.entityLancamento.pesoPotencialMedioMensal = calcularPesoMedioMensal(this.entityLancamento.pesoPotencial);
        // Obtendo o status pretendido
        this.entityLancamento.statusPretendido = this.clienteAnaliseMercadoStatusPretendidoService.getStatusPretendido(this.entityLancamento.quantidadePotencial, this.entityLancamento.pesoPotencial, this.entityLancamento.valorPotencial, this.entityLancamento.quantidadePretendida, this.entityLancamento.pesoPretendido, this.entityLancamento.valorPretendido, this.entityLancamento.quantidadeRealizada, this.entityLancamento.pesoRealizado, this.entityLancamento.valorRealizado);
        // Obtendo o status projetado
        // this.entityLancamento.statusProjetado = this.clienteAnaliseMercadoStatusProjetadoService.getStatusProjetado(this.entityLancamento.statusProjetado, this.entityLancamento.quantidadeProjetada, this.entityLancamento.pesoProjetado, this.entityLancamento.valorProjetado, this.entityLancamento.quantidadeRealizada, this.entityLancamento.pesoRealizado, this.entityLancamento.valorRealizado);
    }

    /** Calcula o Customer Share do ano */
    private calcularCustomerShareAno(valorPotencial: number, valorPretendido: number, valorRealizado: number) {
        const customerShare = new CustomerShareValueObject(this.configCliente.customerShareOtimo, this.configCliente.customerShareBom, this.configCliente.customerShareRazoavel, valorPotencial, valorPretendido, valorRealizado);
        // Pretendido
        this.entityLancamento.valorPretendidoPerc = customerShare.valorPretendidoPerc;
        this.entityLancamento.indicadorCustomerSharePretendido = customerShare.indicadorPretendido.id;
        // Realizado
        this.entityLancamento.indicadorCustomerShareRealizado = customerShare.indicadorRealizado.id;
    }

    onChangeValorPotencialAnual(valorPotencial: number) {
        // Setando o valor potencial anual
        this.changeValorPotencialAnual(valorPotencial);
        // Setando o valor potencial médio mensal nos 12 meses
        this.setValorPotencialMedioMensalMeses();
    }
    private changeValorPotencialAnual(valorPotencial: number) {
        this.entityLancamento.valorPotencial = valorPotencial;

        // Calculando o Customer Share do ano
        this.calcularCustomerShareAno(this.entityLancamento.valorPotencial, this.entityLancamento.valorPretendido, this.entityLancamento.valorRealizado);

        // Calculando o percentual de participação do valor projetado sobre o valor potencial anual
        this.entityLancamento.valorProjetadoPerc = calcularValorProjetadoPerc(this.entityLancamento.valorProjetado, this.entityLancamento.valorPotencial);
        // Calculando o valor potencial médio mensal
        this.entityLancamento.valorPotencialMedioMensal = calcularValorMedioMensal(this.entityLancamento.valorPotencial);
        // Obtendo o status pretendido
        this.entityLancamento.statusPretendido = this.clienteAnaliseMercadoStatusPretendidoService.getStatusPretendido(this.entityLancamento.quantidadePotencial, this.entityLancamento.pesoPotencial, this.entityLancamento.valorPotencial, this.entityLancamento.quantidadePretendida, this.entityLancamento.pesoPretendido, this.entityLancamento.valorPretendido, this.entityLancamento.quantidadeRealizada, this.entityLancamento.pesoRealizado, this.entityLancamento.valorRealizado);
        // Obtendo o status do projetado
        // this.entityLancamento.statusProjetado = this.clienteAnaliseMercadoStatusProjetadoService.getStatusProjetado(this.entityLancamento.statusProjetado, this.entityLancamento.quantidadeProjetada, this.entityLancamento.pesoProjetado, this.entityLancamento.valorProjetado, this.entityLancamento.quantidadeRealizada, this.entityLancamento.pesoRealizado, this.entityLancamento.valorRealizado);
    }

    onChangeQuantidadePretendidaAnual(quantidadePretendida: number) {
        // Setando a quantidade pretendida anual
        this.changeQuantidadePretendidaAnual(quantidadePretendida);
        // Setando a quantidade pretendida média mensal nos 12 meses
        this.setQuantidadePretendidaMediaMensalMeses();

        // Calculando o valor pretendido anual
        const valorPretendido = calcularValorPretendido(this.entityLancamento.quantidadePretendida, this.entityLancamento.quantidadePretendidaValorUnitario, 2);
        this.onChangeValorPretendidoAnual(valorPretendido, false);

        // Setando quantidade projetada igual a quantidade pretendida
        this.onChangeQuantidadeProjetadaAnual(quantidadePretendida);
    }
    private changeQuantidadePretendidaAnual(quantidadePretendida: number) {
        this.entityLancamento.quantidadePretendida = quantidadePretendida;
        // Calculando o percentual de participação da quantidade pretendida sobre a quantidade potencial anual
        this.entityLancamento.quantidadePretendidaPerc = calcularQuantidadePretendidaPerc(this.entityLancamento.quantidadePretendida, this.entityLancamento.quantidadePotencial);
        // Calculando o percentual de participação da quantidade realizada sobre a quantidade projetada anual
        this.entityLancamento.quantidadeRealizadaPercPretendida = calcularQuantidadeRealizadaPerc(this.entityLancamento.quantidadeRealizada, this.entityLancamento.quantidadePretendida);
        // Calcular o percentual de evolução da quantidade pretendida
        this.entityLancamento.quantidadePretendidaPercEvolucao = calcularPercEvolucao(this.entityLancamento.quantidadeRealizadaAnoAnterior1, this.entityLancamento.quantidadePretendida);
        // Calculando a quantidade pretendida média mensal
        this.entityLancamento.quantidadePretendidaMediaMensal = calcularQuantidadeMediaMensal(this.entityLancamento.quantidadePretendida);
        // Obtendo o status pretendido
        this.entityLancamento.statusPretendido = this.clienteAnaliseMercadoStatusPretendidoService.getStatusPretendido(this.entityLancamento.quantidadePotencial, this.entityLancamento.pesoPotencial, this.entityLancamento.valorPotencial, this.entityLancamento.quantidadePretendida, this.entityLancamento.pesoPretendido, this.entityLancamento.valorPretendido, this.entityLancamento.quantidadeRealizada, this.entityLancamento.pesoRealizado, this.entityLancamento.valorRealizado);
    }

    /** Ao alterar o percentual da quantidade pretendida anual */
    onChangeQuantidadePretendidaPercAnual(quantidadePretendidaPerc: number) {
        // Calculando a participação da quantidade pretendida sobre a quantidade potencial
        const quantidadePretendida = calcularParticipacaoQuantidadePretendida(this.entityLancamento.quantidadePotencial, quantidadePretendidaPerc);
        // Delegando para o método de alteração da quantidade pretendida anual realizar os demais cálculos
        this.onChangeQuantidadePretendidaAnual(quantidadePretendida);
    }

    private onChangeQuantidadeProjetadaAnual(quantidadeProjetada: number) {
        // Setando quantidade projetada
        this.changeQuantidadeProjetadaAnual(quantidadeProjetada);
        // Setando a quantidade projetada média mensal nos 12 meses
        this.setQuantidadeProjetadaMediaMensalMeses();

        // Calculando o valor projetado anual
        const valorProjetado = calcularValorProjetado(this.entityLancamento.quantidadeProjetada, this.entityLancamento.quantidadeProjetadaValorUnitario, 2);
        this.onChangeValorProjetadoAnual(valorProjetado);
    }
    private changeQuantidadeProjetadaAnual(quantidadeProjetada: number) {
        this.entityLancamento.quantidadeProjetada = quantidadeProjetada;
        // Calculando o percentual de participação da quantidade projetada sobre a quantidade potencial anual
        this.entityLancamento.quantidadeProjetadaPerc = calcularQuantidadeProjetadaPerc(this.entityLancamento.quantidadeProjetada, this.entityLancamento.quantidadePotencial);
        // Calculando o percentual de participação da quantidade realizada sobre a quantidade projetada anual
        this.entityLancamento.quantidadeRealizadaPercProjetada = calcularQuantidadeRealizadaPerc(this.entityLancamento.quantidadeRealizada, this.entityLancamento.quantidadeProjetada);
        // Calcular o percentual de evolução da quantidade projetada
        this.entityLancamento.quantidadeProjetadaPercEvolucao = calcularPercEvolucao(this.entityLancamento.quantidadeRealizadaAnoAnterior1, this.entityLancamento.quantidadeProjetada);
        // Calculando a quantidade projetada média mensal
        this.entityLancamento.quantidadeProjetadaMediaMensal = calcularQuantidadeMediaMensal(this.entityLancamento.quantidadeProjetada);
        // Obtendo o status do projetado
        // this.entityLancamento.statusProjetado = this.clienteAnaliseMercadoStatusProjetadoService.getStatusProjetado(this.entityLancamento.statusProjetado, this.entityLancamento.quantidadeProjetada, this.entityLancamento.pesoProjetado, this.entityLancamento.valorProjetado, this.entityLancamento.quantidadeRealizada, this.entityLancamento.pesoRealizado, this.entityLancamento.valorRealizado);
    }

    onChangePesoPretendidoAnual(pesoPretendido: number) {
        // Setando o peso pretendido anual
        this.changePesoPretendidoAnual(pesoPretendido);
        // Setando o peso pretendido médio mensal nos 12 meses
        this.setPesoPretendidoMedioMensalMeses();

        // Calculando o valor pretendido anual
        const valorPretendido = calcularValorPretendido(this.entityLancamento.pesoPretendido, this.entityLancamento.pesoPretendidoValorUnitario, 2);
        this.onChangeValorPretendidoAnual(valorPretendido, false);

        // Setando peso projetado igual ao peso pretendido
        this.onChangePesoProjetadoAnual(pesoPretendido);
    }
    private changePesoPretendidoAnual(pesoPretendido: number) {
        this.entityLancamento.pesoPretendido = pesoPretendido;
        // Calculando o percentual de participação do peso pretendido sobre o peso potencial anual
        this.entityLancamento.pesoPretendidoPerc = calcularPesoPretendidoPerc(this.entityLancamento.pesoPretendido, this.entityLancamento.pesoPotencial);
        // Calculando o percentual de participação do peso realizado sobre o peso pretendido anual
        this.entityLancamento.pesoRealizadoPercPretendido = calcularPesoRealizadoPerc(this.entityLancamento.pesoRealizado, this.entityLancamento.pesoPretendido);
        // Calcular o percentual de evolução da peso pretendido
        this.entityLancamento.pesoPretendidoPercEvolucao = calcularPercEvolucao(this.entityLancamento.pesoRealizadoAnoAnterior1, this.entityLancamento.pesoPretendido);
        // Calculando o peso pretendido médio mensal
        this.entityLancamento.pesoPretendidoMedioMensal = calcularPesoMedioMensal(this.entityLancamento.pesoPretendido);
        // Obtendo o status pretendido
        this.entityLancamento.statusPretendido = this.clienteAnaliseMercadoStatusPretendidoService.getStatusPretendido(this.entityLancamento.quantidadePotencial, this.entityLancamento.pesoPotencial, this.entityLancamento.valorPotencial, this.entityLancamento.quantidadePretendida, this.entityLancamento.pesoPretendido, this.entityLancamento.valorPretendido, this.entityLancamento.quantidadeRealizada, this.entityLancamento.pesoRealizado, this.entityLancamento.valorRealizado);
    }

    /** Ao alterar o percentual do peso pretendido anual */
    onChangePesoPretendidoPercAnual(pesoPretendidoPerc: number) {
        // Calculando a participação do peso pretendido sobre o peso potencial
        const pesoPretendido = calcularParticipacaoPesoPretendido(this.entityLancamento.pesoPotencial, pesoPretendidoPerc);
        // Delegando para o método de alteração do peso pretendido anual realizar os demais cálculos
        this.onChangePesoPretendidoAnual(pesoPretendido);
    }

    private onChangePesoProjetadoAnual(pesoProjetado: number) {
        // Setando o peso projetado anual
        this.changePesoProjetadoAnual(pesoProjetado);
        // Setando o peso projetado médio mensal nos 12 meses
        this.setPesoProjetadoMedioMensalMeses();

        // Calculando o valor projetado anual
        const valorProjetado = calcularValorProjetado(this.entityLancamento.pesoProjetado, this.entityLancamento.pesoProjetadoValorUnitario, 2);
        this.onChangeValorProjetadoAnual(valorProjetado);
    }
    private changePesoProjetadoAnual(pesoProjetado: number) {
        this.entityLancamento.pesoProjetado = pesoProjetado;
        // Calculando o percentual de participação do peso projetado sobre o peso potencial anual
        this.entityLancamento.pesoProjetadoPerc = calcularPesoProjetadoPerc(this.entityLancamento.pesoProjetado, this.entityLancamento.pesoPotencial);
        // Calculando o percentual de participação do peso realizado sobre o peso projetado anual
        this.entityLancamento.pesoRealizadoPercProjetado = calcularPesoRealizadoPerc(this.entityLancamento.pesoRealizado, this.entityLancamento.pesoProjetado);
        // Calcular o percentual de evolução da peso projetado
        this.entityLancamento.pesoProjetadoPercEvolucao = calcularPercEvolucao(this.entityLancamento.pesoRealizadoAnoAnterior1, this.entityLancamento.pesoProjetado);
        // Calculando o peso projetado médio mensal
        this.entityLancamento.pesoProjetadoMedioMensal = calcularPesoMedioMensal(this.entityLancamento.pesoProjetado);
        // Obtendo o status projetado
        // this.entityLancamento.statusProjetado = this.clienteAnaliseMercadoStatusProjetadoService.getStatusProjetado(this.entityLancamento.statusProjetado, this.entityLancamento.quantidadeProjetada, this.entityLancamento.pesoProjetado, this.entityLancamento.valorProjetado, this.entityLancamento.quantidadeRealizada, this.entityLancamento.pesoRealizado, this.entityLancamento.valorRealizado);
    }

    // Realiza o subscribe nas alterações feitas no input do valor pretendido anual
    private subscribeToValorPretendidoAnual() {
        this.valorPretendidoAnualSubscription = this.valorPretendidoAnual?.valueChanges
            .pipe(
                debounceTime(1000), // Dando um debounce de 1000ms para emitir a alteração
                distinctUntilChanged()
            )
            .subscribe((valorPretendidoAnual) => {
                // Obtendo a Classificação RAP através do valor pretendido anual
                this.findClassificacaoRAPByValorFaturamentoAnual(valorPretendidoAnual)
                    .then(classificacaoRAP => this.setClassificacaoRAP(classificacaoRAP))
                    .catch(() => {});
            });
    }

    /** Ao alterar o valor pretendido anual
     *
     * @param valorPretendido valor pretendido anual
     * @param setValorProjetado se deve setar o valor projetado anual igual ao valor pretendido anual
     */
    onChangeValorPretendidoAnual(valorPretendido: number, setValorProjetado: boolean) {
        // Setando o valor pretendido anual
        this.changeValorPretendidoAnual(valorPretendido);
        // Setando o valor pretendido médio mensal nos 12 meses
        this.setValorPretendidoMedioMensalMeses();

        // Setando o valor projetado igual ao valor pretendido
        if (setValorProjetado) {
            this.onChangeValorProjetadoAnual(valorPretendido);
        }
    }
    private changeValorPretendidoAnual(valorPretendido: number) {
        this.entityLancamento.valorPretendido = valorPretendido;

        // Calculando o Customer Share do ano
        this.calcularCustomerShareAno(this.entityLancamento.valorPotencial, this.entityLancamento.valorPretendido, this.entityLancamento.valorRealizado);

        // Calculando o percentual de participação do valor realizado sobre o valor pretendido anual
        this.entityLancamento.valorRealizadoPercPretendido = calcularValorRealizadoPerc(this.entityLancamento.valorRealizado, this.entityLancamento.valorPretendido);
        // Calcular o percentual de evolução da valor pretendido
        this.entityLancamento.valorPretendidoPercEvolucao = calcularPercEvolucao(this.entityLancamento.valorRealizadoAnoAnterior1, this.entityLancamento.valorPretendido);
        // Calculando o valor pretendido médio mensal
        this.entityLancamento.valorPretendidoMedioMensal = calcularValorMedioMensal(this.entityLancamento.valorPretendido);
        // Obtendo o status pretendido
        this.entityLancamento.statusPretendido = this.clienteAnaliseMercadoStatusPretendidoService.getStatusPretendido(this.entityLancamento.quantidadePotencial, this.entityLancamento.pesoPotencial, this.entityLancamento.valorPotencial, this.entityLancamento.quantidadePretendida, this.entityLancamento.pesoPretendido, this.entityLancamento.valorPretendido, this.entityLancamento.quantidadeRealizada, this.entityLancamento.pesoRealizado, this.entityLancamento.valorRealizado);
    }

    /** Ao alterar o percentual do valor pretendido anual */
    onChangeValorPretendidoPercAnual(valorPretendidoPerc: number) {
        // Calculando a participação do valor pretendido sobre o valor potencial
        const valorPretendido = calcularParticipacaoValorPretendido(this.entityLancamento.valorPotencial, valorPretendidoPerc);
        // Delegando para o método de alteração do valor pretendido anual realizar os demais cálculos
        this.onChangeValorPretendidoAnual(valorPretendido, true);
    }

    private onChangeValorProjetadoAnual(valorProjetado: number) {
        // Setando o valor projetado
        this.changeValorProjetadoAnual(valorProjetado);
        // Setando o valor projetado médio mensal nos 12 meses
        this.setValorProjetadoMedioMensalMeses();
    }
    private changeValorProjetadoAnual(valorProjetado: number) {
        this.entityLancamento.valorProjetado = valorProjetado;
        // Calculando o percentual de participação do valor projetado sobre o valor potencial anual
        this.entityLancamento.valorProjetadoPerc = calcularValorProjetadoPerc(this.entityLancamento.valorProjetado, this.entityLancamento.valorPotencial);
        // Calculando o percentual de participação do valor realizado sobre o valor projetado anual
        this.entityLancamento.valorRealizadoPercProjetado = calcularValorRealizadoPerc(this.entityLancamento.valorRealizado, this.entityLancamento.valorProjetado);
        // Calcular o percentual de evolução da valor projetado
        this.entityLancamento.valorProjetadoPercEvolucao = calcularPercEvolucao(this.entityLancamento.valorRealizadoAnoAnterior1, this.entityLancamento.valorProjetado);
        // Calculando o valor projetado médio mensal
        this.entityLancamento.valorProjetadoMedioMensal = calcularValorMedioMensal(this.entityLancamento.valorProjetado);
        // Obtendo o status projetado
        this.entityLancamento.statusProjetado = this.clienteAnaliseMercadoStatusProjetadoService.getStatusProjetado(this.entityLancamento.statusProjetado, this.entityLancamento.quantidadeProjetada, this.entityLancamento.pesoProjetado, this.entityLancamento.valorProjetadoMedioMensal, this.entityLancamento.quantidadeRealizada, this.entityLancamento.pesoRealizado, this.entityLancamento.valorRealizado);
    }

    /** Média Mensal */

    /** Verifica se pode editar o lançamento por quantidade e periodicidade pela média mensal */
    canEditLancamentoQuantidadeMediaMensal(): boolean {
        // Se puder editar e o lançamento for por quantidade e a periodicidade for pela média mensal
        return this.canEdit && this.isLancamentoQuantidade() && this.isPeriodicidadeMediaMensal()
    }

    /** Verifica se pode editar o lançamento por peso e periodicidade pela média mensal */
    canEditLancamentoPesoMediaMensal(): boolean {
        // Se puder editar e o lançamento for por peso e a periodicidade for pela média mensal
        return this.canEdit && this.isLancamentoPeso() && this.isPeriodicidadeMediaMensal()
    }

    /** Verifica se pode editar o lançamento por valor e periodicidade pela média mensal */
    canEditLancamentoValorMediaMensal(): boolean {
        // Se puder editar e o lançamento for por valor e a periodicidade for pela média mensal
        return this.canEdit && this.isLancamentoValor() && this.isPeriodicidadeMediaMensal()
    }

    /** Ao selecionar a periodicidade pela média mensal */
    onSelectPeriodicidadeMediaMensal() {
        /** Removendo os valores unitários para ter que informar um novo valor */
        // Quantidade
        this.entityLancamento.quantidadePretendidaValorUnitario = null;
        this.entityLancamento.quantidadeProjetadaValorUnitario = null;
        // Peso
        this.entityLancamento.pesoPretendidoValorUnitario = null;
        this.entityLancamento.pesoProjetadoValorUnitario = null;
    }

    /** Verifica se o valor unitário é obrigatório ser informado quando o lançamento for por quantidade e a periodicidade for pela média mensal */
    isQuantidadePretendidaValorUnitarioMediaMensalRequired(): boolean {
        // Se o lançamento for por quantidade então não é obrigatório
        if (!this.isLancamentoQuantidade()) {
            return false;
        }
        // Se não solicitar o preço médio então não é obrigatório
        if (!this.entityLancamento?.solicitarPrecoMedio) {
            return false;
        }
        // Se não for o lançamento pela média mensal, então não é obrigatório
        if (!this.isPeriodicidadeMediaMensal()) {
            return false;
        }

        // Se possuir a quantidade potencial média mensal informada é obrigatório
        if ( (this.configAnaliseMercado?.solicitarPotencial) && (this.entityLancamento.quantidadePotencialMediaMensal !== null && this.entityLancamento.quantidadePotencialMediaMensal !== undefined) ) {
            return true;
        }
        // Se possuir a quantidade pretendida média mensal informada é obrigatório
        if (this.entityLancamento.quantidadePretendidaMediaMensal !== null && this.entityLancamento.quantidadePretendidaMediaMensal !== undefined) {
            return true;
        }

        return false;
    }

    /** Ao alterar o valor unitário quando o lançamento for por quantidade e a periodicidade for pela média mensal */
    onChangeQuantidadePretendidaValorUnitarioMedioMensal(quantidadePretendidaValorUnitario: number) {
        // Setando o valor unitário pretendido
        this.entityLancamento.quantidadePretendidaValorUnitario = quantidadePretendidaValorUnitario;

        // Setando o valor unitário nos 12 meses
        this.setQuantidadePretendidaValorUnitarioMeses(this.entityLancamento.quantidadePretendidaValorUnitario);

        // Setando o valor unitário projetado igual ao valor unitário pretendido
        this.onChangeQuantidadeProjetadaValorUnitarioMedioMensal(this.entityLancamento.quantidadePretendidaValorUnitario);
    }

    /** Ao alterar o valor unitário projetado quando o lançamento for por quantidade e a periodicidade for pela média mensal */
    private onChangeQuantidadeProjetadaValorUnitarioMedioMensal(quantidadeProjetadaValorUnitario: number) {
        this.entityLancamento.quantidadeProjetadaValorUnitario = quantidadeProjetadaValorUnitario;

        // Setando o valor unitário nos 12 meses
        this.setQuantidadeProjetadaValorUnitarioMeses(this.entityLancamento.quantidadeProjetadaValorUnitario);
    }

    /** Verifica se o valor unitário é obrigatório ser informado quando o lançamento for por peso e a periodicidade for pela média mensal */
    isPesoPretendidoValorUnitarioMediaMensalRequired(): boolean {
        // Se não for por peso ou peso então não é obrigatório
        if (!this.isLancamentoPeso()) {
            return false;
        }
        // Se não solicitar o preço médio então não é obrigatório
        if (!this.entityLancamento?.solicitarPrecoMedio) {
            return false;
        }
        // Se não for o lançamento pela média mensal, então não é obrigatório
        if (!this.isPeriodicidadeMediaMensal()) {
            return false;
        }

        // Se possuir o peso potencial médio mensal informado é obrigatório
        if ( (this.configAnaliseMercado?.solicitarPotencial) && (this.entityLancamento.pesoPotencialMedioMensal !== null && this.entityLancamento.pesoPotencialMedioMensal !== undefined) ) {
            return true;
        }
        // Se possuir o peso pretendido médio mensal informado é obrigatório
        if (this.entityLancamento.pesoPretendidoMedioMensal !== null && this.entityLancamento.pesoPretendidoMedioMensal !== undefined) {
            return true;
        }

        return false;
    }

    /** Ao alterar o valor unitário quando o lançamento for por peso e a periodicidade for pela média mensal */
    onChangePesoPretendidoValorUnitarioMedioMensal(pesoPretendidoValorUnitario: number) {
        // Setando o valor unitário pretendido
        this.entityLancamento.pesoPretendidoValorUnitario = pesoPretendidoValorUnitario;

        // Setando o valor unitário nos 12 meses
        this.setPesoPretendidoValorUnitarioMeses(this.entityLancamento.pesoPretendidoValorUnitario);

        // Setando o valor unitário projetado igual ao valor pretendido
        this.onChangePesoProjetadoValorUnitarioMedioMensal(this.entityLancamento.pesoPretendidoValorUnitario);
    }

    /** Ao alterar o valor unitário projetado quando o lançamento for por peso e a periodicidade for pela média mensal */
    private onChangePesoProjetadoValorUnitarioMedioMensal(pesoProjetadoValorUnitario: number) {
        this.entityLancamento.pesoProjetadoValorUnitario = pesoProjetadoValorUnitario;

        // Setando o valor unitário nos 12 meses
        this.setPesoProjetadoValorUnitarioMeses(this.entityLancamento.pesoProjetadoValorUnitario);
    }

    onChangeQuantidadePotencialMediaMensal(quantidadePotencialMediaMensal: number) {
        // Setando a quantidade potencial média mensal
        this.changeQuantidadePotencialMediaMensal(quantidadePotencialMediaMensal);
        // Setando a quantidade potencial média mensal nos 12 meses
        this.setQuantidadePotencialMediaMensalMeses();
        // Calculando o valor potencial médio mensal
        const valorPotencialMedioMensal = calcularValorPotencial(this.entityLancamento.quantidadePotencialMediaMensal, this.entityLancamento.quantidadePretendidaValorUnitario);
        this.onChangeValorPotencialMedioMensal(valorPotencialMedioMensal);
    }
    private changeQuantidadePotencialMediaMensal(quantidadePotencialMediaMensal: number) {
        this.entityLancamento.quantidadePotencialMediaMensal = quantidadePotencialMediaMensal;
        // Calculando o percentual de participação da quantidade pretendida sobre a quantidade potencial na média mensal
        this.entityLancamento.quantidadePretendidaPerc = calcularQuantidadePretendidaPerc(this.entityLancamento.quantidadePretendidaMediaMensal, this.entityLancamento.quantidadePotencialMediaMensal);
        // Calculando o percentual de participação da quantidade projetada sobre a quantidade potencial na média mensal
        this.entityLancamento.quantidadeProjetadaPerc = calcularQuantidadeProjetadaPerc(this.entityLancamento.quantidadeProjetadaMediaMensal, this.entityLancamento.quantidadePotencialMediaMensal);
        // Calculando a quantidade potencial anual
        this.entityLancamento.quantidadePotencial = calcularQuantidadeAnual(this.entityLancamento.quantidadePotencialMediaMensal);
        // Obtendo o status pretendido
        this.entityLancamento.statusPretendido = this.clienteAnaliseMercadoStatusPretendidoService.getStatusPretendido(this.entityLancamento.quantidadePotencial, this.entityLancamento.pesoPotencial, this.entityLancamento.valorPotencial, this.entityLancamento.quantidadePretendida, this.entityLancamento.pesoPretendido, this.entityLancamento.valorPretendido, this.entityLancamento.quantidadeRealizada, this.entityLancamento.pesoRealizado, this.entityLancamento.valorRealizado);
        // Obtendo o status projetado
        // this.entityLancamento.statusProjetado = this.clienteAnaliseMercadoStatusProjetadoService.getStatusProjetado(this.entityLancamento.statusProjetado, this.entityLancamento.quantidadeProjetada, this.entityLancamento.pesoProjetado, this.entityLancamento.valorProjetado, this.entityLancamento.quantidadeRealizada, this.entityLancamento.pesoRealizado, this.entityLancamento.valorRealizado);
    }

    onChangePesoPotencialMedioMensal(pesoPotencialMedioMensal: number) {
        // Setando o peso potencial médio mensal
        this.changePesoPotencialMedioMensal(pesoPotencialMedioMensal);
        // Setando o peso potencial médio mensal nos 12 meses
        this.setPesoPotencialMedioMensalMeses();
        // Calculando o valor potencial médio mensal
        const valorPotencialMedioMensal = calcularValorPotencial(this.entityLancamento.pesoPotencialMedioMensal, this.entityLancamento.pesoPretendidoValorUnitario);
        this.onChangeValorPotencialMedioMensal(valorPotencialMedioMensal);
    }
    private changePesoPotencialMedioMensal(pesoPotencialMedioMensal: number) {
        this.entityLancamento.pesoPotencialMedioMensal = pesoPotencialMedioMensal;
        // Calculando o percentual de participação do peso pretendido sobre o peso potencial na média mensal
        this.entityLancamento.pesoPretendidoPerc = calcularPesoPretendidoPerc(this.entityLancamento.pesoPretendidoMedioMensal, this.entityLancamento.pesoPotencialMedioMensal);
        // Calculando o percentual de participação do peso projetado sobre o peso potencial na média mensal
        this.entityLancamento.pesoProjetadoPerc = calcularPesoProjetadoPerc(this.entityLancamento.pesoProjetadoMedioMensal, this.entityLancamento.pesoPotencialMedioMensal);
        // Calculando o peso potencial anual
        this.entityLancamento.pesoPotencial = calcularPesoAnual(this.entityLancamento.pesoPotencialMedioMensal);
        // Obtendo o status pretendido
        this.entityLancamento.statusPretendido = this.clienteAnaliseMercadoStatusPretendidoService.getStatusPretendido(this.entityLancamento.quantidadePotencial, this.entityLancamento.pesoPotencial, this.entityLancamento.valorPotencial, this.entityLancamento.quantidadePretendida, this.entityLancamento.pesoPretendido, this.entityLancamento.valorPretendido, this.entityLancamento.quantidadeRealizada, this.entityLancamento.pesoRealizado, this.entityLancamento.valorRealizado);
        // Obtendo o status projetado
        // this.entityLancamento.statusProjetado = this.clienteAnaliseMercadoStatusProjetadoService.getStatusProjetado(this.entityLancamento.statusProjetado, this.entityLancamento.quantidadeProjetada, this.entityLancamento.pesoProjetado, this.entityLancamento.valorProjetado, this.entityLancamento.quantidadeRealizada, this.entityLancamento.pesoRealizado, this.entityLancamento.valorRealizado);
    }

    onChangeValorPotencialMedioMensal(valorPotencialMedioMensal: number) {
        // Setando o valor potencial médio mensal
        this.changeValorPotencialMedioMensal(valorPotencialMedioMensal);
        // Setando o valor potencial médio mensal nos 12 meses
        this.setValorPotencialMedioMensalMeses();
    }
    private changeValorPotencialMedioMensal(valorPotencialMedioMensal: number) {
        this.entityLancamento.valorPotencialMedioMensal = valorPotencialMedioMensal;

        // Calculando o Customer Share do ano com base na média mensal
        this.calcularCustomerShareAno(this.entityLancamento.valorPotencialMedioMensal, this.entityLancamento.valorPretendidoMedioMensal, this.entityLancamento.valorRealizadoMedioMensal);

        // Calculando o percentual de participação do valor projetado sobre o valor potencial na média mensal
        this.entityLancamento.valorProjetadoPerc = calcularValorProjetadoPerc(this.entityLancamento.valorProjetadoMedioMensal, this.entityLancamento.valorPotencialMedioMensal);
        // Calculando o valor potencial anual
        this.entityLancamento.valorPotencial = calcularValorAnual(this.entityLancamento.valorPotencialMedioMensal);
        // Obtendo o status pretendido
        this.entityLancamento.statusPretendido = this.clienteAnaliseMercadoStatusPretendidoService.getStatusPretendido(this.entityLancamento.quantidadePotencial, this.entityLancamento.pesoPotencial, this.entityLancamento.valorPotencial, this.entityLancamento.quantidadePretendida, this.entityLancamento.pesoPretendido, this.entityLancamento.valorPretendido, this.entityLancamento.quantidadeRealizada, this.entityLancamento.pesoRealizado, this.entityLancamento.valorRealizado);
        // Obtendo o status projetado
        // this.entityLancamento.statusProjetado = this.clienteAnaliseMercadoStatusProjetadoService.getStatusProjetado(this.entityLancamento.statusProjetado, this.entityLancamento.quantidadeProjetada, this.entityLancamento.pesoProjetado, this.entityLancamento.valorProjetado, this.entityLancamento.quantidadeRealizada, this.entityLancamento.pesoRealizado, this.entityLancamento.valorRealizado);
    }

    onChangeQuantidadePretendidaMediaMensal(quantidadePretendidaMediaMensal: number) {
        // Setando a quantidade pretendida média mensal
        this.changeQuantidadePretendidaMediaMensal(quantidadePretendidaMediaMensal);
        // Setando a quantidade pretendida média mensal nos 12 meses
        this.setQuantidadePretendidaMediaMensalMeses();

        // Calculando o valor pretendido médio mensal
        const valorPretendidoMedioMensal = calcularValorPretendido(this.entityLancamento.quantidadePretendidaMediaMensal, this.entityLancamento.quantidadePretendidaValorUnitario);
        this.onChangeValorPretendidoMedioMensal(valorPretendidoMedioMensal, false);

        // Setando a quantidade projetada igual a quantidade pretendida
        this.onChangeQuantidadeProjetadaMediaMensal(quantidadePretendidaMediaMensal);
    }
    private changeQuantidadePretendidaMediaMensal(quantidadePretendidaMediaMensal: number) {
        this.entityLancamento.quantidadePretendidaMediaMensal = quantidadePretendidaMediaMensal;
        // Calculando o percentual de participação da quantidade pretendida sobre a quantidade potencial na média mensal
        this.entityLancamento.quantidadePretendidaPerc = calcularQuantidadePretendidaPerc(this.entityLancamento.quantidadePretendidaMediaMensal, this.entityLancamento.quantidadePotencialMediaMensal);
        // Calculando o percentual de participação da quantidade realizada sobre a quantidade projetada na média mensal
        this.entityLancamento.quantidadeRealizadaPercPretendida = calcularQuantidadeRealizadaPerc(this.entityLancamento.quantidadeRealizadaMediaMensal, this.entityLancamento.quantidadePretendidaMediaMensal);
        // Calcular o percentual de evolução da quantidade pretendida
        this.entityLancamento.quantidadePretendidaPercEvolucao = calcularPercEvolucao(this.entityLancamento.quantidadeRealizadaMediaMensalAnoAnterior1, this.entityLancamento.quantidadePretendidaMediaMensal);
        // Calculando a quantidade pretendida anual
        this.entityLancamento.quantidadePretendida = calcularQuantidadeAnual(this.entityLancamento.quantidadePretendidaMediaMensal);
        // Obtendo o status pretendido
        this.entityLancamento.statusPretendido = this.clienteAnaliseMercadoStatusPretendidoService.getStatusPretendido(this.entityLancamento.quantidadePotencial, this.entityLancamento.pesoPotencial, this.entityLancamento.valorPotencial, this.entityLancamento.quantidadePretendida, this.entityLancamento.pesoPretendido, this.entityLancamento.valorPretendido, this.entityLancamento.quantidadeRealizada, this.entityLancamento.pesoRealizado, this.entityLancamento.valorRealizado);
    }

    /** Ao alterar o percentual da quantidade pretendida da média mensal */
    onChangeQuantidadePretendidaPercMediaMensal(quantidadePretendidaPerc: number) {
        // Calculando a participação da quantidade pretendida sobre a quantidade potencial
        const quantidadePretendida = calcularParticipacaoQuantidadePretendida(this.entityLancamento.quantidadePotencialMediaMensal, quantidadePretendidaPerc);
        // Delegando para o método de alteração da quantidade pretendida da média mensal realizar os demais cálculos
        this.onChangeQuantidadePretendidaMediaMensal(quantidadePretendida);
    }

    private onChangeQuantidadeProjetadaMediaMensal(quantidadeProjetadaMediaMensal: number) {
        // Setando a quantidade projetada
        this.changeQuantidadeProjetadaMediaMensal(quantidadeProjetadaMediaMensal);
        // Setando a quantidade projetada média mensal nos 12 meses
        this.setQuantidadeProjetadaMediaMensalMeses();

        // Calculando o valor projetado médio mensal
        const valorProjetadoMedioMensal = calcularValorProjetado(this.entityLancamento.quantidadeProjetadaMediaMensal, this.entityLancamento.quantidadeProjetadaValorUnitario);
        this.onChangeValorProjetadoMedioMensal(valorProjetadoMedioMensal);
    }
    private changeQuantidadeProjetadaMediaMensal(quantidadeProjetadaMediaMensal: number) {
        this.entityLancamento.quantidadeProjetadaMediaMensal = quantidadeProjetadaMediaMensal;
        // Calculando o percentual de participação da quantidade projetada sobre a quantidade potencial na média mensal
        this.entityLancamento.quantidadeProjetadaPerc = calcularQuantidadeProjetadaPerc(this.entityLancamento.quantidadeProjetadaMediaMensal, this.entityLancamento.quantidadePotencialMediaMensal);
        // Calculando o percentual de participação da quantidade realizada sobre a quantidade projetada na média mensal
        this.entityLancamento.quantidadeRealizadaPercProjetada = calcularQuantidadeRealizadaPerc(this.entityLancamento.quantidadeRealizadaMediaMensal, this.entityLancamento.quantidadeProjetadaMediaMensal);
        // Calcular o percentual de evolução da quantidade projetada
        this.entityLancamento.quantidadeProjetadaPercEvolucao = calcularPercEvolucao(this.entityLancamento.quantidadeRealizadaMediaMensalAnoAnterior1, this.entityLancamento.quantidadeProjetadaMediaMensal);
        // Calculando a quantidade projetada anual
        this.entityLancamento.quantidadeProjetada = calcularQuantidadeAnual(this.entityLancamento.quantidadeProjetadaMediaMensal);
        // Obtendo o status projetado
        this.entityLancamento.statusProjetado = this.clienteAnaliseMercadoStatusProjetadoService.getStatusProjetado(this.entityLancamento.statusProjetado, this.entityLancamento.quantidadeProjetada, this.entityLancamento.pesoProjetado, this.entityLancamento.valorProjetado, this.entityLancamento.quantidadeRealizada, this.entityLancamento.pesoRealizado, this.entityLancamento.valorRealizado);
    }


    onChangePesoPretendidoMedioMensal(pesoPretendidoMedioMensal: number) {
        // Setando o peso pretendido médio mensal
        this.changePesoPretendidoMedioMensal(pesoPretendidoMedioMensal);
        // Setando o peso pretendido médio mensal nos 12 meses
        this.setPesoPretendidoMedioMensalMeses();

        // Calculando o valor pretendido médio mensal
        const valorPretendidoMedioMensal = calcularValorPretendido(this.entityLancamento.pesoPretendidoMedioMensal, this.entityLancamento.pesoPretendidoValorUnitario);
        this.onChangeValorPretendidoMedioMensal(valorPretendidoMedioMensal, false);

        // Setando o peso projetado igual ao peso pretendido
        this.onChangePesoProjetadoMedioMensal(pesoPretendidoMedioMensal);
    }
    private changePesoPretendidoMedioMensal(pesoPretendidoMedioMensal: number) {
        this.entityLancamento.pesoPretendidoMedioMensal = pesoPretendidoMedioMensal;
        // Calculando o percentual de participação do peso pretendido sobre o peso potencial na média mensal
        this.entityLancamento.pesoPretendidoPerc = calcularPesoPretendidoPerc(this.entityLancamento.pesoPretendidoMedioMensal, this.entityLancamento.pesoPotencialMedioMensal);
        // Calculando o percentual de participação do peso realizado sobre o peso pretendido na média mensal
        this.entityLancamento.pesoRealizadoPercPretendido = calcularPesoRealizadoPerc(this.entityLancamento.pesoRealizadoMedioMensal, this.entityLancamento.pesoPretendidoMedioMensal);
        // Calcular o percentual de evolução da peso pretendido
        this.entityLancamento.pesoPretendidoPercEvolucao = calcularPercEvolucao(this.entityLancamento.pesoRealizadoMedioMensalAnoAnterior1, this.entityLancamento.pesoPretendidoMedioMensal);
        // Calculando o peso pretendido anual
        this.entityLancamento.pesoPretendido = calcularPesoAnual(this.entityLancamento.pesoPretendidoMedioMensal);
        // Obtendo o status pretendido
        this.entityLancamento.statusPretendido = this.clienteAnaliseMercadoStatusPretendidoService.getStatusPretendido(this.entityLancamento.quantidadePotencial, this.entityLancamento.pesoPotencial, this.entityLancamento.valorPotencial, this.entityLancamento.quantidadePretendida, this.entityLancamento.pesoPretendido, this.entityLancamento.valorPretendido, this.entityLancamento.quantidadeRealizada, this.entityLancamento.pesoRealizado, this.entityLancamento.valorRealizado);
    }

    /** Ao alterar o percentual do peso pretendido da média mensal */
    onChangePesoPretendidoPercMedioMensal(pesoPretendidoPerc: number) {
        // Calculando a participação do peso pretendido sobre o peso potencial
        const pesoPretendido = calcularParticipacaoPesoPretendido(this.entityLancamento.pesoPotencialMedioMensal, pesoPretendidoPerc);
        // Delegando para o método de alteração do peso pretendido da média mensal realizar os demais cálculos
        this.onChangePesoPretendidoMedioMensal(pesoPretendido);
    }

    private onChangePesoProjetadoMedioMensal(pesoProjetadoMedioMensal: number) {
        // Setando o peso projetado médio mensal
        this.changePesoProjetadoMedioMensal(pesoProjetadoMedioMensal);
        // Setando o peso projetado médio mensal nos 12 meses
        this.setPesoProjetadoMedioMensalMeses();

        // Calculando o valor projetado médio mensal
        const valorProjetadoMedioMensal = calcularValorProjetado(this.entityLancamento.pesoProjetadoMedioMensal, this.entityLancamento.pesoProjetadoValorUnitario);
        this.onChangeValorProjetadoMedioMensal(valorProjetadoMedioMensal);
    }
    private changePesoProjetadoMedioMensal(pesoProjetadoMedioMensal: number) {
        this.entityLancamento.pesoProjetadoMedioMensal = pesoProjetadoMedioMensal;
        // Calculando o percentual de participação do peso projetado sobre o peso potencial na média mensal
        this.entityLancamento.pesoProjetadoPerc = calcularPesoProjetadoPerc(this.entityLancamento.pesoProjetadoMedioMensal, this.entityLancamento.pesoPotencialMedioMensal);
        // Calculando o percentual de participação do peso realizado sobre o peso projetado na média mensal
        this.entityLancamento.pesoRealizadoPercProjetado = calcularPesoRealizadoPerc(this.entityLancamento.pesoRealizadoMedioMensal, this.entityLancamento.pesoProjetadoMedioMensal);
        // Calcular o percentual de evolução da peso projetado
        this.entityLancamento.pesoProjetadoPercEvolucao = calcularPercEvolucao(this.entityLancamento.pesoRealizadoMedioMensalAnoAnterior1, this.entityLancamento.pesoProjetadoMedioMensal);
        // Calculando o peso projetado anual
        this.entityLancamento.pesoProjetado = calcularPesoAnual(this.entityLancamento.pesoProjetadoMedioMensal);
        // Obtendo o status projetado
        this.entityLancamento.statusProjetado = this.clienteAnaliseMercadoStatusProjetadoService.getStatusProjetado(this.entityLancamento.statusProjetado, this.entityLancamento.quantidadeProjetada, this.entityLancamento.pesoProjetado, this.entityLancamento.valorProjetado, this.entityLancamento.quantidadeRealizada, this.entityLancamento.pesoRealizado, this.entityLancamento.valorRealizado);
    }

    /** Ao alterar o valor pretendido médio mensal
     *
     * @param valorPretendidoMedioMensal valor pretendido médio mensal
     * @param setValorProjetado se deve setar o valor projetado médio mensal igual ao valor pretendido médio mensal
     */
    onChangeValorPretendidoMedioMensal(valorPretendidoMedioMensal: number, setValorProjetado: boolean) {
        // Setando o valor pretendido médio mensal
        this.changeValorPretendidoMedioMensal(valorPretendidoMedioMensal);
        // Setando o valor pretendido médio mensal nos 12 meses
        this.setValorPretendidoMedioMensalMeses();

        // Setando o valor projetado igual ao valor pretendido
        if (setValorProjetado) {
            this.onChangeValorProjetadoMedioMensal(valorPretendidoMedioMensal);
        }
    }
    private changeValorPretendidoMedioMensal(valorPretendidoMedioMensal: number) {
        this.entityLancamento.valorPretendidoMedioMensal = valorPretendidoMedioMensal;

        // Calculando o Customer Share do ano com base na média mensal
        this.calcularCustomerShareAno(this.entityLancamento.valorPotencialMedioMensal, this.entityLancamento.valorPretendidoMedioMensal, this.entityLancamento.valorRealizadoMedioMensal);

        // Calculando o percentual de participação do valor realizado sobre o valor pretendido na média mensal
        this.entityLancamento.valorRealizadoPercPretendido = calcularValorRealizadoPerc(this.entityLancamento.valorRealizadoMedioMensal, this.entityLancamento.valorPretendidoMedioMensal);
        // Calcular o percentual de evolução da valor pretendido
        this.entityLancamento.valorPretendidoPercEvolucao = calcularPercEvolucao(this.entityLancamento.valorRealizadoMedioMensalAnoAnterior1, this.entityLancamento.valorPretendidoMedioMensal);
        // Calculando o valor pretendido anual
        this.entityLancamento.valorPretendido = calcularValorAnual(this.entityLancamento.valorPretendidoMedioMensal);
        // Obtendo o status pretendido
        this.entityLancamento.statusPretendido = this.clienteAnaliseMercadoStatusPretendidoService.getStatusPretendido(this.entityLancamento.quantidadePotencial, this.entityLancamento.pesoPotencial, this.entityLancamento.valorPotencial, this.entityLancamento.quantidadePretendida, this.entityLancamento.pesoPretendido, this.entityLancamento.valorPretendido, this.entityLancamento.quantidadeRealizada, this.entityLancamento.pesoRealizado, this.entityLancamento.valorRealizado);
    }

    /** Ao alterar o percentual do valor pretendido da média mensal */
    onChangeValorPretendidoPercMedioMensal(valorPretendidoPerc: number) {
        // Calculando a participação do valor pretendido sobre o valor potencial
        const valorPretendido = calcularParticipacaoValorPretendido(this.entityLancamento.valorPotencialMedioMensal, valorPretendidoPerc);
        // Delegando para o método de alteração do valor pretendido da média mensal realizar os demais cálculos
        this.onChangeValorPretendidoMedioMensal(valorPretendido, true);
    }

    private onChangeValorProjetadoMedioMensal(valorProjetadoMedioMensal: number) {
        // Setando o valor projetado médio mensal
        this.changeValorProjetadoMedioMensal(valorProjetadoMedioMensal);
        // Setando o valor projetado médio mensal nos 12 meses
        this.setValorProjetadoMedioMensalMeses();
    }
    private changeValorProjetadoMedioMensal(valorProjetadoMedioMensal: number) {
        this.entityLancamento.valorProjetadoMedioMensal = valorProjetadoMedioMensal;
        // Calculando o percentual de participação do valor projetado sobre o valor potencial na média mensal
        this.entityLancamento.valorProjetadoPerc = calcularValorProjetadoPerc(this.entityLancamento.valorProjetadoMedioMensal, this.entityLancamento.valorPotencialMedioMensal);
        // Calculando o percentual de participação do valor realizado sobre o valor projetado na média mensal
        this.entityLancamento.valorRealizadoPercProjetado = calcularValorRealizadoPerc(this.entityLancamento.valorRealizadoMedioMensal, this.entityLancamento.valorProjetadoMedioMensal);
        // Calcular o percentual de evolução da valor projetado
        this.entityLancamento.valorProjetadoPercEvolucao = calcularPercEvolucao(this.entityLancamento.valorRealizadoMedioMensalAnoAnterior1, this.entityLancamento.valorProjetadoMedioMensal);
        // Calculando o valor projetado anual
        this.entityLancamento.valorProjetado = calcularValorAnual(this.entityLancamento.valorProjetadoMedioMensal);
        // Obtendo o status projetado
        // this.entityLancamento.statusProjetado = this.clienteAnaliseMercadoStatusProjetadoService.getStatusProjetado(this.entityLancamento.statusProjetado, this.entityLancamento.quantidadeProjetada, this.entityLancamento.pesoProjetado, this.entityLancamento.valorProjetado, this.entityLancamento.quantidadeRealizada, this.entityLancamento.pesoRealizado, this.entityLancamento.valorRealizado);
    }


    /** Trimestral */
    /** Altera a quantidade potencial do trimestre 1 */
    private changeQuantidadePotencialTrimestre1(quantidadePotencialTrimestre1: number) {
        // Setando a quantidade potencial
        this.entityLancamento.quantidadePotencialTrimestre1 = quantidadePotencialTrimestre1;
        // Calculando o percentual de participação da quantidade pretendida
        this.entityLancamento.quantidadePretendidaPercTrimestre1 = calcularQuantidadePretendidaPerc(this.entityLancamento.quantidadePretendidaTrimestre1, this.entityLancamento.quantidadePotencialTrimestre1);
        // Calculando o percentual de participação da quantidade projetada
        this.entityLancamento.quantidadeProjetadaPercTrimestre1 = calcularQuantidadeProjetadaPerc(this.entityLancamento.quantidadeProjetadaTrimestre1, this.entityLancamento.quantidadePotencialTrimestre1);
    }
    /** Altera a quantidade potencial do trimestre 2 */
    private changeQuantidadePotencialTrimestre2(quantidadePotencialTrimestre2: number) {
        // Setando a quantidade potencial
        this.entityLancamento.quantidadePotencialTrimestre2 = quantidadePotencialTrimestre2;
        // Calculando o percentual de participação da quantidade pretendida
        this.entityLancamento.quantidadePretendidaPercTrimestre2 = calcularQuantidadePretendidaPerc(this.entityLancamento.quantidadePretendidaTrimestre2, this.entityLancamento.quantidadePotencialTrimestre2);
        // Calculando o percentual de participação da quantidade projetada
        this.entityLancamento.quantidadeProjetadaPercTrimestre2 = calcularQuantidadeProjetadaPerc(this.entityLancamento.quantidadeProjetadaTrimestre2, this.entityLancamento.quantidadePotencialTrimestre2);
    }
    /** Altera a quantidade potencial do trimestre 3 */
    private changeQuantidadePotencialTrimestre3(quantidadePotencialTrimestre3: number) {
        // Setando a quantidade potencial
        this.entityLancamento.quantidadePotencialTrimestre3 = quantidadePotencialTrimestre3;
        // Calculando o percentual de participação da quantidade pretendida
        this.entityLancamento.quantidadePretendidaPercTrimestre3 = calcularQuantidadePretendidaPerc(this.entityLancamento.quantidadePretendidaTrimestre3, this.entityLancamento.quantidadePotencialTrimestre3);
        // Calculando o percentual de participação da quantidade projetada
        this.entityLancamento.quantidadeProjetadaPercTrimestre3 = calcularQuantidadeProjetadaPerc(this.entityLancamento.quantidadeProjetadaTrimestre3, this.entityLancamento.quantidadePotencialTrimestre3);
    }
    /** Altera a quantidade potencial do trimestre 4 */
    private changeQuantidadePotencialTrimestre4(quantidadePotencialTrimestre4: number) {
        // Setando a quantidade potencial
        this.entityLancamento.quantidadePotencialTrimestre4 = quantidadePotencialTrimestre4;
        // Calculando o percentual de participação da quantidade pretendida
        this.entityLancamento.quantidadePretendidaPercTrimestre4 = calcularQuantidadePretendidaPerc(this.entityLancamento.quantidadePretendidaTrimestre4, this.entityLancamento.quantidadePotencialTrimestre4);
        // Calculando o percentual de participação da quantidade projetada
        this.entityLancamento.quantidadeProjetadaPercTrimestre4 = calcularQuantidadeProjetadaPerc(this.entityLancamento.quantidadeProjetadaTrimestre4, this.entityLancamento.quantidadePotencialTrimestre4);
    }

    /** Altera o peso potencial do trimestre 1 */
    private changePesoPotencialTrimestre1(pesoPotencialTrimestre1: number) {
        // Setando o peso potencial
        this.entityLancamento.pesoPotencialTrimestre1 = pesoPotencialTrimestre1;
        // Calculando o percentual de participação do peso pretendido
        this.entityLancamento.pesoPretendidoPercTrimestre1 = calcularPesoPretendidoPerc(this.entityLancamento.pesoPretendidoTrimestre1, this.entityLancamento.pesoPotencialTrimestre1);
        // Calculando o percentual de participação do peso projetado
        this.entityLancamento.pesoProjetadoPercTrimestre1 = calcularPesoProjetadoPerc(this.entityLancamento.pesoProjetadoTrimestre1, this.entityLancamento.pesoPotencialTrimestre1);
    }
    /** Altera o peso potencial do trimestre 2 */
    private changePesoPotencialTrimestre2(pesoPotencialTrimestre2: number) {
        // Setando o peso potencial
        this.entityLancamento.pesoPotencialTrimestre2 = pesoPotencialTrimestre2;
        // Calculando o percentual de participação do peso pretendido
        this.entityLancamento.pesoPretendidoPercTrimestre2 = calcularPesoPretendidoPerc(this.entityLancamento.pesoPretendidoTrimestre2, this.entityLancamento.pesoPotencialTrimestre2);
        // Calculando o percentual de participação do peso projetado
        this.entityLancamento.pesoProjetadoPercTrimestre2 = calcularPesoProjetadoPerc(this.entityLancamento.pesoProjetadoTrimestre2, this.entityLancamento.pesoPotencialTrimestre2);
    }
    /** Altera o peso potencial do trimestre 3 */
    private changePesoPotencialTrimestre3(pesoPotencialTrimestre3: number) {
        // Setando o peso potencial
        this.entityLancamento.pesoPotencialTrimestre3 = pesoPotencialTrimestre3;
        // Calculando o percentual de participação do peso pretendido
        this.entityLancamento.pesoPretendidoPercTrimestre3 = calcularPesoPretendidoPerc(this.entityLancamento.pesoPretendidoTrimestre3, this.entityLancamento.pesoPotencialTrimestre3);
        // Calculando o percentual de participação do peso projetado
        this.entityLancamento.pesoProjetadoPercTrimestre3 = calcularPesoProjetadoPerc(this.entityLancamento.pesoProjetadoTrimestre3, this.entityLancamento.pesoPotencialTrimestre3);
    }
    /** Altera o peso potencial do trimestre 4 */
    private changePesoPotencialTrimestre4(pesoPotencialTrimestre4: number) {
        // Setando o peso potencial
        this.entityLancamento.pesoPotencialTrimestre4 = pesoPotencialTrimestre4;
        // Calculando o percentual de participação do peso pretendido
        this.entityLancamento.pesoPretendidoPercTrimestre4 = calcularPesoPretendidoPerc(this.entityLancamento.pesoPretendidoTrimestre4, this.entityLancamento.pesoPotencialTrimestre4);
        // Calculando o percentual de participação do peso projetado
        this.entityLancamento.pesoProjetadoPercTrimestre4 = calcularPesoProjetadoPerc(this.entityLancamento.pesoProjetadoTrimestre4, this.entityLancamento.pesoPotencialTrimestre4);
    }

    /** Calcula o Customer Share do trimestre 1 */
    private calcularCustomerShareTrimeste1() {
        const customerShare = new CustomerShareValueObject(this.configCliente.customerShareOtimo, this.configCliente.customerShareBom, this.configCliente.customerShareRazoavel, this.entityLancamento.valorPotencialTrimestre1, this.entityLancamento.valorPretendidoTrimestre1, this.entityLancamento.valorRealizadoTrimestre1);
        // Pretendido
        this.entityLancamento.valorPretendidoPercTrimestre1 = customerShare.valorPretendidoPerc;
        this.entityLancamento.indicadorCustomerSharePretendidoTrimestre1 = customerShare.indicadorPretendido.id;
        // Realizado
        this.entityLancamento.indicadorCustomerShareRealizadoTrimestre1 = customerShare.indicadorRealizado.id;
    }

    /** Calcula o Customer Share do trimestre 2 */
    private calcularCustomerShareTrimeste2() {
        const customerShare = new CustomerShareValueObject(this.configCliente.customerShareOtimo, this.configCliente.customerShareBom, this.configCliente.customerShareRazoavel, this.entityLancamento.valorPotencialTrimestre2, this.entityLancamento.valorPretendidoTrimestre2, this.entityLancamento.valorRealizadoTrimestre2);
        // Pretendido
        this.entityLancamento.valorPretendidoPercTrimestre2 = customerShare.valorPretendidoPerc;
        this.entityLancamento.indicadorCustomerSharePretendidoTrimestre2 = customerShare.indicadorPretendido.id;
        // Realizado
        this.entityLancamento.indicadorCustomerShareRealizadoTrimestre2 = customerShare.indicadorRealizado.id;
    }

    /** Calcula o Customer Share do trimestre 3 */
    private calcularCustomerShareTrimeste3() {
        const customerShare = new CustomerShareValueObject(this.configCliente.customerShareOtimo, this.configCliente.customerShareBom, this.configCliente.customerShareRazoavel, this.entityLancamento.valorPotencialTrimestre3, this.entityLancamento.valorPretendidoTrimestre3, this.entityLancamento.valorRealizadoTrimestre3);
        // Pretendido
        this.entityLancamento.valorPretendidoPercTrimestre3 = customerShare.valorPretendidoPerc;
        this.entityLancamento.indicadorCustomerSharePretendidoTrimestre3 = customerShare.indicadorPretendido.id;
        // Realizado
        this.entityLancamento.indicadorCustomerShareRealizadoTrimestre3 = customerShare.indicadorRealizado.id;
    }

    /** Calcula o Customer Share do trimestre 4 */
    private calcularCustomerShareTrimeste4() {
        const customerShare = new CustomerShareValueObject(this.configCliente.customerShareOtimo, this.configCliente.customerShareBom, this.configCliente.customerShareRazoavel, this.entityLancamento.valorPotencialTrimestre4, this.entityLancamento.valorPretendidoTrimestre4, this.entityLancamento.valorRealizadoTrimestre4);
        // Pretendido
        this.entityLancamento.valorPretendidoPercTrimestre4 = customerShare.valorPretendidoPerc;
        this.entityLancamento.indicadorCustomerSharePretendidoTrimestre4 = customerShare.indicadorPretendido.id;
        // Realizado
        this.entityLancamento.indicadorCustomerShareRealizadoTrimestre4 = customerShare.indicadorRealizado.id;
    }

    /** Altera o valor potencial do trimestre 1 */
    private changeValorPotencialTrimestre1(valorPotencialTrimestre1: number) {
        // Setando o valor potencial
        this.entityLancamento.valorPotencialTrimestre1 = valorPotencialTrimestre1;

        // Calculando o Customer Share do Trimestre 1
        this.calcularCustomerShareTrimeste1();

        // Calculando o percentual de participação do valor projetado
        this.entityLancamento.valorProjetadoPercTrimestre1 = calcularValorProjetadoPerc(this.entityLancamento.valorProjetadoTrimestre1, this.entityLancamento.valorPotencialTrimestre1);
    }
    /** Altera o valor potencial do trimestre 2 */
    private changeValorPotencialTrimestre2(valorPotencialTrimestre2: number) {
        // Setando o valor potencial
        this.entityLancamento.valorPotencialTrimestre2 = valorPotencialTrimestre2;

        // Calculando o Customer Share do Trimestre 2
        this.calcularCustomerShareTrimeste2();

        // Calculando o percentual de participação do valor projetado
        this.entityLancamento.valorProjetadoPercTrimestre2 = calcularValorProjetadoPerc(this.entityLancamento.valorProjetadoTrimestre2, this.entityLancamento.valorPotencialTrimestre2);
    }
    /** Altera o valor potencial do trimestre 3 */
    private changeValorPotencialTrimestre3(valorPotencialTrimestre3: number) {
        // Setando o valor potencial
        this.entityLancamento.valorPotencialTrimestre3 = valorPotencialTrimestre3;

        // Calculando o Customer Share do Trimestre 3
        this.calcularCustomerShareTrimeste3();

        // Calculando o percentual de participação do valor projetado
        this.entityLancamento.valorProjetadoPercTrimestre3 = calcularValorProjetadoPerc(this.entityLancamento.valorProjetadoTrimestre3, this.entityLancamento.valorPotencialTrimestre3);
    }
    /** Altera o valor potencial do trimestre 4 */
    private changeValorPotencialTrimestre4(valorPotencialTrimestre4: number) {
        // Setando o valor potencial
        this.entityLancamento.valorPotencialTrimestre4 = valorPotencialTrimestre4;

        // Calculando o Customer Share do Trimestre 4
        this.calcularCustomerShareTrimeste4();

        // Calculando o percentual de participação do valor projetado
        this.entityLancamento.valorProjetadoPercTrimestre4 = calcularValorProjetadoPerc(this.entityLancamento.valorProjetadoTrimestre4, this.entityLancamento.valorPotencialTrimestre4);
    }

    /** Altera a quantidade pretendida do trimestre 1 */
    private changeQuantidadePretendidaTrimestre1(quantidadePretendidaTrimestre1: number) {
        // Setando a quantidade pretendida
        this.entityLancamento.quantidadePretendidaTrimestre1 = quantidadePretendidaTrimestre1;
        // Calculando o percentual de participação da quantidade pretendida
        this.entityLancamento.quantidadePretendidaPercTrimestre1 = calcularQuantidadePretendidaPerc(this.entityLancamento.quantidadePretendidaTrimestre1, this.entityLancamento.quantidadePotencialTrimestre1);
        // Calculando o percentual de participação da quantidade realizada
        this.entityLancamento.quantidadeRealizadaPercPretendidaTrimestre1 = calcularQuantidadeRealizadaPerc(this.entityLancamento.quantidadeRealizadaTrimestre1, this.entityLancamento.quantidadePretendidaTrimestre1);
        // Calcular o percentual de evolução da quantidade pretendida
        this.entityLancamento.quantidadePretendidaPercEvolucaoTrimestre1 = calcularPercEvolucao(this.entityLancamento.quantidadeRealizadaTrimestre1AnoAnterior1, this.entityLancamento.quantidadePretendidaTrimestre1);
    }
    /** Altera a quantidade pretendida do trimestre 2 */
    private changeQuantidadePretendidaTrimestre2(quantidadePretendidaTrimestre2: number) {
        // Setando a quantidade pretendida
        this.entityLancamento.quantidadePretendidaTrimestre2 = quantidadePretendidaTrimestre2;
        // Calculando o percentual de participação da quantidade pretendida
        this.entityLancamento.quantidadePretendidaPercTrimestre2 = calcularQuantidadePretendidaPerc(this.entityLancamento.quantidadePretendidaTrimestre2, this.entityLancamento.quantidadePotencialTrimestre2);
        // Calculando o percentual de participação da quantidade realizdada
        this.entityLancamento.quantidadeRealizadaPercPretendidaTrimestre2 = calcularQuantidadeRealizadaPerc(this.entityLancamento.quantidadeRealizadaTrimestre2, this.entityLancamento.quantidadePretendidaTrimestre2);
        // Calcular o percentual de evolução da quantidade pretendida
        this.entityLancamento.quantidadePretendidaPercEvolucaoTrimestre2 = calcularPercEvolucao(this.entityLancamento.quantidadeRealizadaTrimestre2AnoAnterior1, this.entityLancamento.quantidadePretendidaTrimestre2);
    }
    /** Altera a quantidade pretendida do trimestre 3 */
    private changeQuantidadePretendidaTrimestre3(quantidadePretendidaTrimestre3: number) {
        // Setando a quantidade pretendida
        this.entityLancamento.quantidadePretendidaTrimestre3 = quantidadePretendidaTrimestre3;
        // Calculando o percentual de participação da quantidade pretendida
        this.entityLancamento.quantidadePretendidaPercTrimestre3 = calcularQuantidadePretendidaPerc(this.entityLancamento.quantidadePretendidaTrimestre3, this.entityLancamento.quantidadePotencialTrimestre3);
        // Calculando o percentual de participação da quantidade realizada
        this.entityLancamento.quantidadeRealizadaPercPretendidaTrimestre3 = calcularQuantidadeRealizadaPerc(this.entityLancamento.quantidadeRealizadaTrimestre3, this.entityLancamento.quantidadePretendidaTrimestre3);
        // Calcular o percentual de evolução da quantidade pretendida
        this.entityLancamento.quantidadePretendidaPercEvolucaoTrimestre3 = calcularPercEvolucao(this.entityLancamento.quantidadeRealizadaTrimestre3AnoAnterior1, this.entityLancamento.quantidadePretendidaTrimestre3);
    }
    /** Altera a quantidade pretendida do trimestre 4 */
    private changeQuantidadePretendidaTrimestre4(quantidadePretendidaTrimestre4: number) {
        // Setando a quantidade pretendida
        this.entityLancamento.quantidadePretendidaTrimestre4 = quantidadePretendidaTrimestre4;
        // Calculando o percentual de participação da quantidade pretendida
        this.entityLancamento.quantidadePretendidaPercTrimestre4 = calcularQuantidadePretendidaPerc(this.entityLancamento.quantidadePretendidaTrimestre4, this.entityLancamento.quantidadePotencialTrimestre4);
        // Calculando o percentual de participação da quantidade realizada
        this.entityLancamento.quantidadeRealizadaPercPretendidaTrimestre4 = calcularQuantidadeRealizadaPerc(this.entityLancamento.quantidadeRealizadaTrimestre4, this.entityLancamento.quantidadePretendidaTrimestre4);
        // Calcular o percentual de evolução da quantidade pretendida
        this.entityLancamento.quantidadePretendidaPercEvolucaoTrimestre4 = calcularPercEvolucao(this.entityLancamento.quantidadeRealizadaTrimestre4AnoAnterior1, this.entityLancamento.quantidadePretendidaTrimestre4);
    }

    /** Altera o peso pretendido do trimestre 1 */
    private changePesoPretendidoTrimestre1(pesoPretendidoTrimestre1: number) {
        // Setando o peso pretendido
        this.entityLancamento.pesoPretendidoTrimestre1 = pesoPretendidoTrimestre1;
        // Calculando o percentual de participação do peso pretendido
        this.entityLancamento.pesoPretendidoPercTrimestre1 = calcularPesoPretendidoPerc(this.entityLancamento.pesoPretendidoTrimestre1, this.entityLancamento.pesoPotencialTrimestre1);
        // Calculando o percentual de participação do peso realizado
        this.entityLancamento.pesoRealizadoPercPretendidoTrimestre1 = calcularPesoRealizadoPerc(this.entityLancamento.pesoRealizadoTrimestre1, this.entityLancamento.pesoPretendidoTrimestre1);
        // Calcular o percentual de evolução da peso pretendido
        this.entityLancamento.pesoPretendidoPercEvolucaoTrimestre1 = calcularPercEvolucao(this.entityLancamento.pesoRealizadoTrimestre1AnoAnterior1, this.entityLancamento.pesoPretendidoTrimestre1);
    }
    /** Altera o peso pretendido do trimestre 2 */
    private changePesoPretendidoTrimestre2(pesoPretendidoTrimestre2: number) {
        // Setando o peso pretendido
        this.entityLancamento.pesoPretendidoTrimestre2 = pesoPretendidoTrimestre2;
        // Calculando o percentual de participação do peso pretendido
        this.entityLancamento.pesoPretendidoPercTrimestre2 = calcularPesoPretendidoPerc(this.entityLancamento.pesoPretendidoTrimestre2, this.entityLancamento.pesoPotencialTrimestre2);
        // Calculando o percentual de participação do peso realizado
        this.entityLancamento.pesoRealizadoPercPretendidoTrimestre2 = calcularPesoRealizadoPerc(this.entityLancamento.pesoRealizadoTrimestre2, this.entityLancamento.pesoPretendidoTrimestre2);
        // Calcular o percentual de evolução da peso pretendido
        this.entityLancamento.pesoPretendidoPercEvolucaoTrimestre2 = calcularPercEvolucao(this.entityLancamento.pesoRealizadoTrimestre2AnoAnterior1, this.entityLancamento.pesoPretendidoTrimestre2);
    }
    /** Altera o peso pretendido do trimestre 3 */
    private changePesoPretendidoTrimestre3(pesoPretendidoTrimestre3: number) {
        // Setando o peso pretendido
        this.entityLancamento.pesoPretendidoTrimestre3 = pesoPretendidoTrimestre3;
        // Calculando o percentual de participação do peso pretendido
        this.entityLancamento.pesoPretendidoPercTrimestre3 = calcularPesoPretendidoPerc(this.entityLancamento.pesoPretendidoTrimestre3, this.entityLancamento.pesoPotencialTrimestre3);
        // Calculando o percentual de participação do peso realizado
        this.entityLancamento.pesoRealizadoPercPretendidoTrimestre3 = calcularPesoRealizadoPerc(this.entityLancamento.pesoRealizadoTrimestre3, this.entityLancamento.pesoPretendidoTrimestre3);
        // Calcular o percentual de evolução da peso pretendido
        this.entityLancamento.pesoPretendidoPercEvolucaoTrimestre3 = calcularPercEvolucao(this.entityLancamento.pesoRealizadoTrimestre3AnoAnterior1, this.entityLancamento.pesoPretendidoTrimestre3);
    }
    /** Altera o peso pretendido do trimestre 4 */
    private changePesoPretendidoTrimestre4(pesoPretendidoTrimestre4: number) {
        // Setando o peso pretendido
        this.entityLancamento.pesoPretendidoTrimestre4 = pesoPretendidoTrimestre4;
        // Calculando o percentual de participação do peso pretendido
        this.entityLancamento.pesoPretendidoPercTrimestre4 = calcularPesoPretendidoPerc(this.entityLancamento.pesoPretendidoTrimestre4, this.entityLancamento.pesoPotencialTrimestre4);
        // Calculando o percentual de participação do peso realizado
        this.entityLancamento.pesoRealizadoPercPretendidoTrimestre4 = calcularPesoRealizadoPerc(this.entityLancamento.pesoRealizadoTrimestre4, this.entityLancamento.pesoPretendidoTrimestre4);
        // Calcular o percentual de evolução da peso pretendido
        this.entityLancamento.pesoPretendidoPercEvolucaoTrimestre4 = calcularPercEvolucao(this.entityLancamento.pesoRealizadoTrimestre4AnoAnterior1, this.entityLancamento.pesoPretendidoTrimestre4);
    }

    /** Altera o valor pretendido do trimestre 1 */
    private changeValorPretendidoTrimestre1(valorPretendidoTrimestre1: number) {
        // Setando o valor pretendido
        this.entityLancamento.valorPretendidoTrimestre1 = valorPretendidoTrimestre1;

        // Calculando o Customer Share do Trimestre 1
        this.calcularCustomerShareTrimeste1();

        // Calculando o percentual de participação do valor realizado
        this.entityLancamento.valorRealizadoPercPretendidoTrimestre1 = calcularValorRealizadoPerc(this.entityLancamento.valorRealizadoTrimestre1, this.entityLancamento.valorPretendidoTrimestre1);
        // Calcular o percentual de evolução da valor pretendido
        this.entityLancamento.valorPretendidoPercEvolucaoTrimestre1 = calcularPercEvolucao(this.entityLancamento.valorRealizadoTrimestre1AnoAnterior1, this.entityLancamento.valorPretendidoTrimestre1);
    }
    /** Altera o valor pretendido do trimestre 2 */
    private changeValorPretendidoTrimestre2(valorPretendidoTrimestre2: number) {
        // Setando o valor pretendido
        this.entityLancamento.valorPretendidoTrimestre2 = valorPretendidoTrimestre2;

        // Calculando o Customer Share do Trimestre 2
        this.calcularCustomerShareTrimeste2();

        // Calculando o percentual de participação do valor realizado
        this.entityLancamento.valorRealizadoPercPretendidoTrimestre2 = calcularValorRealizadoPerc(this.entityLancamento.valorRealizadoTrimestre2, this.entityLancamento.valorPretendidoTrimestre2);
        // Calcular o percentual de evolução da valor pretendido
        this.entityLancamento.valorPretendidoPercEvolucaoTrimestre2 = calcularPercEvolucao(this.entityLancamento.valorRealizadoTrimestre2AnoAnterior1, this.entityLancamento.valorPretendidoTrimestre2);
    }
    /** Altera o valor pretendido do trimestre 3 */
    private changeValorPretendidoTrimestre3(valorPretendidoTrimestre3: number) {
        // Setando o valor pretendido
        this.entityLancamento.valorPretendidoTrimestre3 = valorPretendidoTrimestre3;

        // Calculando o Customer Share do Trimestre 3
        this.calcularCustomerShareTrimeste3();

        // Calculando o percentual de participação do valor realizado
        this.entityLancamento.valorRealizadoPercPretendidoTrimestre3 = calcularValorRealizadoPerc(this.entityLancamento.valorRealizadoTrimestre3, this.entityLancamento.valorPretendidoTrimestre3);
        // Calcular o percentual de evolução da valor pretendido
        this.entityLancamento.valorPretendidoPercEvolucaoTrimestre3 = calcularPercEvolucao(this.entityLancamento.valorRealizadoTrimestre3AnoAnterior1, this.entityLancamento.valorPretendidoTrimestre3);
    }
    /** Altera o valor pretendido do trimestre 4 */
    private changeValorPretendidoTrimestre4(valorPretendidoTrimestre4: number) {
        // Setando o valor pretendido
        this.entityLancamento.valorPretendidoTrimestre4 = valorPretendidoTrimestre4;

        // Calculando o Customer Share do Trimestre 4
        this.calcularCustomerShareTrimeste4();

        // Calculando o percentual de participação do valor realizado
        this.entityLancamento.valorRealizadoPercPretendidoTrimestre4 = calcularValorRealizadoPerc(this.entityLancamento.valorRealizadoTrimestre4, this.entityLancamento.valorPretendidoTrimestre4);
        // Calcular o percentual de evolução da valor pretendido
        this.entityLancamento.valorPretendidoPercEvolucaoTrimestre4 = calcularPercEvolucao(this.entityLancamento.valorRealizadoTrimestre4AnoAnterior1, this.entityLancamento.valorPretendidoTrimestre4);
    }

    /** Altera a quantidade projetada do trimestre 1 */
    private changeQuantidadeProjetadaTrimestre1(quantidadeProjetadaTrimestre1: number) {
        // Setando a quantidade projetada
        this.entityLancamento.quantidadeProjetadaTrimestre1 = quantidadeProjetadaTrimestre1;
        // Calculando o percentual de participação da quantidade projetada
        this.entityLancamento.quantidadeProjetadaPercTrimestre1 = calcularQuantidadeProjetadaPerc(this.entityLancamento.quantidadeProjetadaTrimestre1, this.entityLancamento.quantidadePotencialTrimestre1);
        // Calculando o percentual de participação da quantidade realizada
        this.entityLancamento.quantidadeRealizadaPercProjetadaTrimestre1 = calcularQuantidadeRealizadaPerc(this.entityLancamento.quantidadeRealizadaTrimestre1, this.entityLancamento.quantidadeProjetadaTrimestre1);
        // Calcular o percentual de evolução da quantidade projetada
        this.entityLancamento.quantidadeProjetadaPercEvolucaoTrimestre1 = calcularPercEvolucao(this.entityLancamento.quantidadeRealizadaTrimestre1AnoAnterior1, this.entityLancamento.quantidadeProjetadaTrimestre1);
    }
    /** Altera a quantidade projetada do trimestre 2 */
    private changeQuantidadeProjetadaTrimestre2(quantidadeProjetadaTrimestre2: number) {
        // Setando a quantidade projetada
        this.entityLancamento.quantidadeProjetadaTrimestre2 = quantidadeProjetadaTrimestre2;
        // Calculando o percentual de participação da quantidade projetada
        this.entityLancamento.quantidadeProjetadaPercTrimestre2 = calcularQuantidadeProjetadaPerc(this.entityLancamento.quantidadeProjetadaTrimestre2, this.entityLancamento.quantidadePotencialTrimestre2);
        // Calculando o percentual de participação da quantidade realizada
        this.entityLancamento.quantidadeRealizadaPercProjetadaTrimestre2 = calcularQuantidadeRealizadaPerc(this.entityLancamento.quantidadeRealizadaTrimestre2, this.entityLancamento.quantidadeProjetadaTrimestre2);
        // Calcular o percentual de evolução da quantidade projetada
        this.entityLancamento.quantidadeProjetadaPercEvolucaoTrimestre2 = calcularPercEvolucao(this.entityLancamento.quantidadeRealizadaTrimestre2AnoAnterior1, this.entityLancamento.quantidadeProjetadaTrimestre2);
    }
    /** Altera a quantidade projetada do trimestre 3 */
    private changeQuantidadeProjetadaTrimestre3(quantidadeProjetadaTrimestre3: number) {
        // Setando a quantidade projetada
        this.entityLancamento.quantidadeProjetadaTrimestre3 = quantidadeProjetadaTrimestre3;
        // Calculando o percentual de participação da quantidade projetada
        this.entityLancamento.quantidadeProjetadaPercTrimestre3 = calcularQuantidadeProjetadaPerc(this.entityLancamento.quantidadeProjetadaTrimestre3, this.entityLancamento.quantidadePotencialTrimestre3);
        // Calculando o percentual de participação da quantidade realizada
        this.entityLancamento.quantidadeRealizadaPercProjetadaTrimestre3 = calcularQuantidadeRealizadaPerc(this.entityLancamento.quantidadeRealizadaTrimestre3, this.entityLancamento.quantidadeProjetadaTrimestre3);
        // Calcular o percentual de evolução da quantidade projetada
        this.entityLancamento.quantidadeProjetadaPercEvolucaoTrimestre3 = calcularPercEvolucao(this.entityLancamento.quantidadeRealizadaTrimestre3AnoAnterior1, this.entityLancamento.quantidadeProjetadaTrimestre3);
    }
    /** Altera a quantidade projetada do trimestre 4 */
    private changeQuantidadeProjetadaTrimestre4(quantidadeProjetadaTrimestre4: number) {
        // Setando a quantidade projetada
        this.entityLancamento.quantidadeProjetadaTrimestre4 = quantidadeProjetadaTrimestre4;
        // Calculando o percentual de participação da quantidade projetada
        this.entityLancamento.quantidadeProjetadaPercTrimestre4 = calcularQuantidadeProjetadaPerc(this.entityLancamento.quantidadeProjetadaTrimestre4, this.entityLancamento.quantidadePotencialTrimestre4);
        // Calculando o percentual de participação da quantidade realizada
        this.entityLancamento.quantidadeRealizadaPercProjetadaTrimestre4 = calcularQuantidadeRealizadaPerc(this.entityLancamento.quantidadeRealizadaTrimestre4, this.entityLancamento.quantidadeProjetadaTrimestre4);
        // Calcular o percentual de evolução da quantidade projetada
        this.entityLancamento.quantidadeProjetadaPercEvolucaoTrimestre4 = calcularPercEvolucao(this.entityLancamento.quantidadeRealizadaTrimestre4AnoAnterior1, this.entityLancamento.quantidadeProjetadaTrimestre4);
    }

    /** Altera o peso projetado do trimestre 1 */
    private changePesoProjetadoTrimestre1(pesoProjetadoTrimestre1: number) {
        // Setando o peso projetadp
        this.entityLancamento.pesoProjetadoTrimestre1 = pesoProjetadoTrimestre1;
        // Calculando o percentual de participação do peso projetado
        this.entityLancamento.pesoProjetadoPercTrimestre1 = calcularPesoProjetadoPerc(this.entityLancamento.pesoProjetadoTrimestre1, this.entityLancamento.pesoPotencialTrimestre1);
        // Calculando o percentual de participação do peso realizado
        this.entityLancamento.pesoRealizadoPercProjetadoTrimestre1 = calcularPesoRealizadoPerc(this.entityLancamento.pesoRealizadoTrimestre1, this.entityLancamento.pesoProjetadoTrimestre1);
        // Calcular o percentual de evolução da peso projetado
        this.entityLancamento.pesoProjetadoPercEvolucaoTrimestre1 = calcularPercEvolucao(this.entityLancamento.pesoRealizadoTrimestre1AnoAnterior1, this.entityLancamento.pesoProjetadoTrimestre1);
    }
    /** Altera o peso projetado do trimestre 2 */
    private changePesoProjetadoTrimestre2(pesoProjetadoTrimestre2: number) {
        // Setando o peso projetado
        this.entityLancamento.pesoProjetadoTrimestre2 = pesoProjetadoTrimestre2;
        // Calculando o percentual de participação do peso projetado
        this.entityLancamento.pesoProjetadoPercTrimestre2 = calcularPesoProjetadoPerc(this.entityLancamento.pesoProjetadoTrimestre2, this.entityLancamento.pesoPotencialTrimestre2);
        // Calculando o percentual de participação do peso realizado
        this.entityLancamento.pesoRealizadoPercProjetadoTrimestre2 = calcularPesoRealizadoPerc(this.entityLancamento.pesoRealizadoTrimestre2, this.entityLancamento.pesoProjetadoTrimestre2);
        // Calcular o percentual de evolução da peso projetado
        this.entityLancamento.pesoProjetadoPercEvolucaoTrimestre2 = calcularPercEvolucao(this.entityLancamento.pesoRealizadoTrimestre2AnoAnterior1, this.entityLancamento.pesoProjetadoTrimestre2);
    }
    /** Altera o peso projetado do trimestre 3 */
    private changePesoProjetadoTrimestre3(pesoProjetadoTrimestre3: number) {
        // Setando o peso projetado
        this.entityLancamento.pesoProjetadoTrimestre3 = pesoProjetadoTrimestre3;
        // Calculando o percentual de participação do peso projetado
        this.entityLancamento.pesoProjetadoPercTrimestre3 = calcularPesoProjetadoPerc(this.entityLancamento.pesoProjetadoTrimestre3, this.entityLancamento.pesoPotencialTrimestre3);
        // Calculando o percentual de participação do peso realizado
        this.entityLancamento.pesoRealizadoPercProjetadoTrimestre3 = calcularPesoRealizadoPerc(this.entityLancamento.pesoRealizadoTrimestre3, this.entityLancamento.pesoProjetadoTrimestre3);
        // Calcular o percentual de evolução da peso projetado
        this.entityLancamento.pesoProjetadoPercEvolucaoTrimestre3 = calcularPercEvolucao(this.entityLancamento.pesoRealizadoTrimestre3AnoAnterior1, this.entityLancamento.pesoProjetadoTrimestre3);
    }
    /** Altera o peso projetado do trimestre 4 */
    private changePesoProjetadoTrimestre4(pesoProjetadoTrimestre4: number) {
        // Setando o peso projetado
        this.entityLancamento.pesoProjetadoTrimestre4 = pesoProjetadoTrimestre4;
        // Calculando o percentual de participação do peso projetado
        this.entityLancamento.pesoProjetadoPercTrimestre4 = calcularPesoProjetadoPerc(this.entityLancamento.pesoProjetadoTrimestre4, this.entityLancamento.pesoPotencialTrimestre4);
        // Calculando o percentual de participação do peso realizado
        this.entityLancamento.pesoRealizadoPercProjetadoTrimestre4 = calcularPesoRealizadoPerc(this.entityLancamento.pesoRealizadoTrimestre4, this.entityLancamento.pesoProjetadoTrimestre4);
        // Calcular o percentual de evolução da peso projetado
        this.entityLancamento.pesoProjetadoPercEvolucaoTrimestre4 = calcularPercEvolucao(this.entityLancamento.pesoRealizadoTrimestre4AnoAnterior1, this.entityLancamento.pesoProjetadoTrimestre4);
    }

    /** Altera o valor projetado do trimestre 1 */
    private changeValorProjetadoTrimestre1(valorProjetadoTrimestre1: number) {
        // Setando o valor projetado
        this.entityLancamento.valorProjetadoTrimestre1 = valorProjetadoTrimestre1;
        // Calculando o percentual de participação do valor projetado
        this.entityLancamento.valorProjetadoPercTrimestre1 = calcularValorProjetadoPerc(this.entityLancamento.valorProjetadoTrimestre1, this.entityLancamento.valorPotencialTrimestre1);
        // Calculando o percentual de participação do valor realizado
        this.entityLancamento.valorRealizadoPercProjetadoTrimestre1 = calcularValorRealizadoPerc(this.entityLancamento.valorRealizadoTrimestre1, this.entityLancamento.valorProjetadoTrimestre1);
        // Calcular o percentual de evolução da valor projetado
        this.entityLancamento.valorProjetadoPercEvolucaoTrimestre1 = calcularPercEvolucao(this.entityLancamento.valorRealizadoTrimestre1AnoAnterior1, this.entityLancamento.valorProjetadoTrimestre1);
    }
    /** Altera o valor projetado do trimestre 2 */
    private changeValorProjetadoTrimestre2(valorProjetadoTrimestre2: number) {
        // Setando o valor projetado
        this.entityLancamento.valorProjetadoTrimestre2 = valorProjetadoTrimestre2;
        // Calculando o percentual de participação do valor projetado
        this.entityLancamento.valorProjetadoPercTrimestre2 = calcularValorProjetadoPerc(this.entityLancamento.valorProjetadoTrimestre2, this.entityLancamento.valorPotencialTrimestre2);
        // Calculando o percentual de participação do valor realizado
        this.entityLancamento.valorRealizadoPercProjetadoTrimestre2 = calcularValorRealizadoPerc(this.entityLancamento.valorRealizadoTrimestre2, this.entityLancamento.valorProjetadoTrimestre2);
        // Calcular o percentual de evolução da valor projetado
        this.entityLancamento.valorProjetadoPercEvolucaoTrimestre2 = calcularPercEvolucao(this.entityLancamento.valorRealizadoTrimestre2AnoAnterior1, this.entityLancamento.valorProjetadoTrimestre2);
    }
    /** Altera o valor projetado do trimestre 3 */
    private changeValorProjetadoTrimestre3(valorProjetadoTrimestre3: number) {
        // Setando o valor projetado
        this.entityLancamento.valorProjetadoTrimestre3 = valorProjetadoTrimestre3;
        // Calculando o percentual de participação do valor projetado
        this.entityLancamento.valorProjetadoPercTrimestre3 = calcularValorProjetadoPerc(this.entityLancamento.valorProjetadoTrimestre3, this.entityLancamento.valorPotencialTrimestre3);
        // Calculando o percentual de participação do valor realizado
        this.entityLancamento.valorRealizadoPercProjetadoTrimestre3 = calcularValorRealizadoPerc(this.entityLancamento.valorRealizadoTrimestre3, this.entityLancamento.valorProjetadoTrimestre3);
        // Calcular o percentual de evolução da valor projetado
        this.entityLancamento.valorProjetadoPercEvolucaoTrimestre3 = calcularPercEvolucao(this.entityLancamento.valorRealizadoTrimestre3AnoAnterior1, this.entityLancamento.valorProjetadoTrimestre3);
    }
    /** Altera o valor projetado do trimestre 4 */
    private changeValorProjetadoTrimestre4(valorProjetadoTrimestre4: number) {
        // Setando o valor projetado
        this.entityLancamento.valorProjetadoTrimestre4 = valorProjetadoTrimestre4;
        // Calculando o percentual de participação do valor projetado
        this.entityLancamento.valorProjetadoPercTrimestre4 = calcularValorProjetadoPerc(this.entityLancamento.valorProjetadoTrimestre4, this.entityLancamento.valorPotencialTrimestre4);
        // Calculando o percentual de participação do valor realizado
        this.entityLancamento.valorRealizadoPercProjetadoTrimestre4 = calcularValorRealizadoPerc(this.entityLancamento.valorRealizadoTrimestre4, this.entityLancamento.valorProjetadoTrimestre4);
        // Calcular o percentual de evolução da valor projetado
        this.entityLancamento.valorProjetadoPercEvolucaoTrimestre4 = calcularPercEvolucao(this.entityLancamento.valorRealizadoTrimestre4AnoAnterior1, this.entityLancamento.valorProjetadoTrimestre4);
    }

    /** Semestral */
    /** Altera a quantidade potencial do semestre 1 */
    private changeQuantidadePotencialSemestre1(quantidadePotencialSemestre1: number) {
        // Setando a quantidade potencial
        this.entityLancamento.quantidadePotencialSemestre1 = quantidadePotencialSemestre1;
        // Calculando o percentual de participação da quantidade pretendida
        this.entityLancamento.quantidadePretendidaPercSemestre1 = calcularQuantidadePretendidaPerc(this.entityLancamento.quantidadePretendidaSemestre1, this.entityLancamento.quantidadePotencialSemestre1);
        // Calculando o percentual de participação da quantidade projetada
        this.entityLancamento.quantidadeProjetadaPercSemestre1 = calcularQuantidadeProjetadaPerc(this.entityLancamento.quantidadeProjetadaSemestre1, this.entityLancamento.quantidadePotencialSemestre1);
    }
    /** Altera a quantidade potencial do semestre 2 */
    private changeQuantidadePotencialSemestre2(quantidadePotencialSemestre2: number) {
        // Setando a quantidade potencial
        this.entityLancamento.quantidadePotencialSemestre2 = quantidadePotencialSemestre2;
        // Calculando o percentual de participação da quantidade pretendida
        this.entityLancamento.quantidadePretendidaPercSemestre2 = calcularQuantidadePretendidaPerc(this.entityLancamento.quantidadePretendidaSemestre2, this.entityLancamento.quantidadePotencialSemestre2);
        // Calculando o percentual de participação da quantidade projetada
        this.entityLancamento.quantidadeProjetadaPercSemestre2 = calcularQuantidadeProjetadaPerc(this.entityLancamento.quantidadeProjetadaSemestre2, this.entityLancamento.quantidadePotencialSemestre2);
    }

     /** Altera o peso potencial do semestre 1 */
     private changePesoPotencialSemestre1(pesoPotencialSemestre1: number) {
        // Setando o peso potencial
        this.entityLancamento.pesoPotencialSemestre1 = pesoPotencialSemestre1;
        // Calculando o percentual de participação do peso pretendido
        this.entityLancamento.pesoPretendidoPercSemestre1 = calcularPesoPretendidoPerc(this.entityLancamento.pesoPretendidoSemestre1, this.entityLancamento.pesoPotencialSemestre1);
        // Calculando o percentual de participação do peso projetado
        this.entityLancamento.pesoProjetadoPercSemestre1 = calcularPesoProjetadoPerc(this.entityLancamento.pesoProjetadoSemestre1, this.entityLancamento.pesoPotencialSemestre1);
    }
    /** Altera o peso potencial do semestre 2 */
    private changePesoPotencialSemestre2(pesoPotencialSemestre2: number) {
        // Setando o peso potencial
        this.entityLancamento.pesoPotencialSemestre2 = pesoPotencialSemestre2;
        // Calculando o percentual de participação do peso pretendido
        this.entityLancamento.pesoPretendidoPercSemestre2 = calcularPesoPretendidoPerc(this.entityLancamento.pesoPretendidoSemestre2, this.entityLancamento.pesoPotencialSemestre2);
        // Calculando o percentual de participação do peso projetado
        this.entityLancamento.pesoProjetadoPercSemestre2 = calcularPesoProjetadoPerc(this.entityLancamento.pesoProjetadoSemestre2, this.entityLancamento.pesoPotencialSemestre2);
    }

    /** Calcula o Customer Share do semestre 1 */
    private calcularCustomerShareSemestre1() {
        const customerShare = new CustomerShareValueObject(this.configCliente.customerShareOtimo, this.configCliente.customerShareBom, this.configCliente.customerShareRazoavel, this.entityLancamento.valorPotencialSemestre1, this.entityLancamento.valorPretendidoSemestre1, this.entityLancamento.valorRealizadoSemestre1);
        // Pretendido
        this.entityLancamento.valorPretendidoPercSemestre1 = customerShare.valorPretendidoPerc;
        this.entityLancamento.indicadorCustomerSharePretendidoSemestre1 = customerShare.indicadorPretendido.id;
        // Realizado
        this.entityLancamento.indicadorCustomerShareRealizadoSemestre1 = customerShare.indicadorRealizado.id;
    }

    /** Calcula o Customer Share do semestre 2 */
    private calcularCustomerShareSemestre2() {
        const customerShare = new CustomerShareValueObject(this.configCliente.customerShareOtimo, this.configCliente.customerShareBom, this.configCliente.customerShareRazoavel, this.entityLancamento.valorPotencialSemestre2, this.entityLancamento.valorPretendidoSemestre2, this.entityLancamento.valorRealizadoSemestre2);
        // Pretendido
        this.entityLancamento.valorPretendidoPercSemestre2 = customerShare.valorPretendidoPerc;
        this.entityLancamento.indicadorCustomerSharePretendidoSemestre2 = customerShare.indicadorPretendido.id;
        // Realizado
        this.entityLancamento.indicadorCustomerShareRealizadoSemestre2 = customerShare.indicadorRealizado.id;
    }

    /** Altera o valor potencial do semestre 1 */
    private changeValorPotencialSemestre1(valorPotencialSemestre1: number) {
        // Setando o valor potencial
        this.entityLancamento.valorPotencialSemestre1 = valorPotencialSemestre1;

        // Calculando o Customer Share do semestre 1
        this.calcularCustomerShareSemestre1();

        // Calculando o percentual de participação do valor projetado
        this.entityLancamento.valorProjetadoPercSemestre1 = calcularValorProjetadoPerc(this.entityLancamento.valorProjetadoSemestre1, this.entityLancamento.valorPotencialSemestre1);
    }
    /** Altera o valor potencial do semestre 2 */
    private changeValorPotencialSemestre2(valorPotencialSemestre2: number) {
        // Setando o valor potencial
        this.entityLancamento.valorPotencialSemestre2 = valorPotencialSemestre2;

        // Calculando o Customer Share do semestre 2
        this.calcularCustomerShareSemestre2();

        // Calculando o percentual de participação do valor projetado
        this.entityLancamento.valorProjetadoPercSemestre2 = calcularValorProjetadoPerc(this.entityLancamento.valorProjetadoSemestre2, this.entityLancamento.valorPotencialSemestre2);
    }

    /** Altera a quantidade pretendida do semestre 1 */
    private changeQuantidadePretendidaSemestre1(quantidadePretendidaSemestre1: number) {
        // Setando a quantidade pretendida
        this.entityLancamento.quantidadePretendidaSemestre1 = quantidadePretendidaSemestre1;
        // Calculando o percentual de participação da quantidade pretendida
        this.entityLancamento.quantidadePretendidaPercSemestre1 = calcularQuantidadePretendidaPerc(this.entityLancamento.quantidadePretendidaSemestre1, this.entityLancamento.quantidadePotencialSemestre1);
        // Calculando o percentual de participação da quantidade realizada
        this.entityLancamento.quantidadeRealizadaPercPretendidaSemestre1 = calcularQuantidadeRealizadaPerc(this.entityLancamento.quantidadeRealizadaSemestre1, this.entityLancamento.quantidadePretendidaSemestre1);
        // Calcular o percentual de evolução da quantidade pretendida
        this.entityLancamento.quantidadePretendidaPercEvolucaoSemestre1 = calcularPercEvolucao(this.entityLancamento.quantidadeRealizadaSemestre1AnoAnterior1, this.entityLancamento.quantidadePretendidaSemestre1);
    }
    /** Altera a quantidade pretendida do semestre 2 */
    private changeQuantidadePretendidaSemestre2(quantidadePretendidaSemestre2: number) {
        // Setando a quantidade pretendida
        this.entityLancamento.quantidadePretendidaSemestre2 = quantidadePretendidaSemestre2;
        // Calculando o percentual de participação da quantidade pretendida
        this.entityLancamento.quantidadePretendidaPercSemestre2 = calcularQuantidadePretendidaPerc(this.entityLancamento.quantidadePretendidaSemestre2, this.entityLancamento.quantidadePotencialSemestre2);
        // Calculando o percentual de participação da quantidade realizada
        this.entityLancamento.quantidadeRealizadaPercPretendidaSemestre2 = calcularQuantidadeRealizadaPerc(this.entityLancamento.quantidadeRealizadaSemestre2, this.entityLancamento.quantidadePretendidaSemestre2);
        // Calcular o percentual de evolução da quantidade pretendida
        this.entityLancamento.quantidadePretendidaPercEvolucaoSemestre2 = calcularPercEvolucao(this.entityLancamento.quantidadeRealizadaSemestre2AnoAnterior1, this.entityLancamento.quantidadePretendidaSemestre2);
    }

    /** Altera o peso pretendido do semestre 1 */
    private changePesoPretendidoSemestre1(pesoPretendidoSemestre1: number) {
        // Setando o peso pretendido
        this.entityLancamento.pesoPretendidoSemestre1 = pesoPretendidoSemestre1;
        // Calculando o percentual de participação do peso pretendido
        this.entityLancamento.pesoPretendidoPercSemestre1 = calcularPesoPretendidoPerc(this.entityLancamento.pesoPretendidoSemestre1, this.entityLancamento.pesoPotencialSemestre1);
        // Calculando o percentual de participação do peso realizado
        this.entityLancamento.pesoRealizadoPercPretendidoSemestre1 = calcularPesoRealizadoPerc(this.entityLancamento.pesoRealizadoSemestre1, this.entityLancamento.pesoPretendidoSemestre1);
        // Calcular o percentual de evolução da peso pretendido
        this.entityLancamento.pesoPretendidoPercEvolucaoSemestre1 = calcularPercEvolucao(this.entityLancamento.pesoRealizadoSemestre1AnoAnterior1, this.entityLancamento.pesoPretendidoSemestre1);
    }
    /** Altera o peso pretendido do semestre 2 */
    private changePesoPretendidoSemestre2(pesoPretendidoSemestre2: number) {
        // Setando o peso pretendido
        this.entityLancamento.pesoPretendidoSemestre2 = pesoPretendidoSemestre2;
        // Calculando o percentual de participação do peso pretendido
        this.entityLancamento.pesoPretendidoPercSemestre2 = calcularPesoPretendidoPerc(this.entityLancamento.pesoPretendidoSemestre2, this.entityLancamento.pesoPotencialSemestre2);
        // Calculando o percentual de participação do peso realizado
        this.entityLancamento.pesoRealizadoPercPretendidoSemestre2 = calcularPesoRealizadoPerc(this.entityLancamento.pesoRealizadoSemestre2, this.entityLancamento.pesoPretendidoSemestre2);
        // Calcular o percentual de evolução da peso pretendido
        this.entityLancamento.pesoPretendidoPercEvolucaoSemestre2 = calcularPercEvolucao(this.entityLancamento.pesoRealizadoSemestre2AnoAnterior1, this.entityLancamento.pesoPretendidoSemestre2);
    }

    /** Altera o valor pretendido do semestre 1 */
    private changeValorPretendidoSemestre1(valorPretendidoSemestre1: number) {
        // Setando o valor pretendido
        this.entityLancamento.valorPretendidoSemestre1 = valorPretendidoSemestre1;

        // Calculando o Customer Share do semestre 1
        this.calcularCustomerShareSemestre1();

        // Calculando o percentual de participação do valor realizado
        this.entityLancamento.valorRealizadoPercPretendidoSemestre1 = calcularValorRealizadoPerc(this.entityLancamento.valorRealizadoSemestre1, this.entityLancamento.valorPretendidoSemestre1);
        // Calcular o percentual de evolução da valor pretendido
        this.entityLancamento.valorPretendidoPercEvolucaoSemestre1 = calcularPercEvolucao(this.entityLancamento.valorRealizadoSemestre1AnoAnterior1, this.entityLancamento.valorPretendidoSemestre1);
    }
    /** Altera o valor pretendido do semestre 2 */
    private changeValorPretendidoSemestre2(valorPretendidoSemestre2: number) {
        // Setando o valor pretendido
        this.entityLancamento.valorPretendidoSemestre2 = valorPretendidoSemestre2;

        // Calculando o Customer Share do semestre 2
        this.calcularCustomerShareSemestre2();

        // Calculando o percentual de participação do valor realizado
        this.entityLancamento.valorRealizadoPercPretendidoSemestre2 = calcularValorRealizadoPerc(this.entityLancamento.valorRealizadoSemestre2, this.entityLancamento.valorPretendidoSemestre2);
        // Calcular o percentual de evolução da valor pretendido
        this.entityLancamento.valorPretendidoPercEvolucaoSemestre2 = calcularPercEvolucao(this.entityLancamento.valorRealizadoSemestre2AnoAnterior1, this.entityLancamento.valorPretendidoSemestre2);
    }

    /** Altera a quantidade projetada do semestre 1 */
    private changeQuantidadeProjetadaSemestre1(quantidadeProjetadaSemestre1: number) {
        // Setando a quantidade projetada
        this.entityLancamento.quantidadeProjetadaSemestre1 = quantidadeProjetadaSemestre1;
        // Calculando o percentual de participação da quantidade projetada
        this.entityLancamento.quantidadeProjetadaPercSemestre1 = calcularQuantidadeProjetadaPerc(this.entityLancamento.quantidadeProjetadaSemestre1, this.entityLancamento.quantidadePotencialSemestre1);
        // Calculando o percentual de participação da quantidade realizada
        this.entityLancamento.quantidadeRealizadaPercProjetadaSemestre1 = calcularQuantidadeRealizadaPerc(this.entityLancamento.quantidadeRealizadaSemestre1, this.entityLancamento.quantidadeProjetadaSemestre1);
        // Calcular o percentual de evolução da quantidade projetada
        this.entityLancamento.quantidadeProjetadaPercEvolucaoSemestre1 = calcularPercEvolucao(this.entityLancamento.quantidadeRealizadaSemestre1AnoAnterior1, this.entityLancamento.quantidadeProjetadaSemestre1);
    }
    /** Altera a quantidade projetada do semestre 2 */
    private changeQuantidadeProjetadaSemestre2(quantidadeProjetadaSemestre2: number) {
        // Setando a quantidade projetada
        this.entityLancamento.quantidadeProjetadaSemestre2 = quantidadeProjetadaSemestre2;
        // Calculando o percentual de participação da quantidade projetada
        this.entityLancamento.quantidadeProjetadaPercSemestre2 = calcularQuantidadeProjetadaPerc(this.entityLancamento.quantidadeProjetadaSemestre2, this.entityLancamento.quantidadePotencialSemestre2);
        // Calculando o percentual de participação da quantidade realizada
        this.entityLancamento.quantidadeRealizadaPercProjetadaSemestre2 = calcularQuantidadeRealizadaPerc(this.entityLancamento.quantidadeRealizadaSemestre2, this.entityLancamento.quantidadeProjetadaSemestre2);
        // Calcular o percentual de evolução da quantidade projetada
        this.entityLancamento.quantidadeProjetadaPercEvolucaoSemestre2 = calcularPercEvolucao(this.entityLancamento.quantidadeRealizadaSemestre1AnoAnterior2, this.entityLancamento.quantidadeProjetadaSemestre2);
    }

    /** Altera o peso projetado do semestre 1 */
    private changePesoProjetadoSemestre1(pesoProjetadoSemestre1: number) {
        // Setando o peso projetado
        this.entityLancamento.pesoProjetadoSemestre1 = pesoProjetadoSemestre1;
        // Calculando o percentual de participação do peso projetado
        this.entityLancamento.pesoProjetadoPercSemestre1 = calcularPesoProjetadoPerc(this.entityLancamento.pesoProjetadoSemestre1, this.entityLancamento.pesoPotencialSemestre1);
        // Calculando o percentual de participação do peso realizado
        this.entityLancamento.pesoRealizadoPercProjetadoSemestre1 = calcularPesoRealizadoPerc(this.entityLancamento.pesoRealizadoSemestre1, this.entityLancamento.pesoProjetadoSemestre1);
        // Calcular o percentual de evolução da peso projetado
        this.entityLancamento.pesoProjetadoPercEvolucaoSemestre1 = calcularPercEvolucao(this.entityLancamento.pesoRealizadoSemestre1AnoAnterior1, this.entityLancamento.pesoProjetadoSemestre1);
    }
    /** Altera o peso projetado do semestre 2 */
    private changePesoProjetadoSemestre2(pesoProjetadoSemestre2: number) {
        // Setando o peso projetado
        this.entityLancamento.pesoProjetadoSemestre2 = pesoProjetadoSemestre2;
        // Calculando o percentual de participação do peso projetado
        this.entityLancamento.pesoProjetadoPercSemestre2 = calcularPesoProjetadoPerc(this.entityLancamento.pesoProjetadoSemestre2, this.entityLancamento.pesoPotencialSemestre2);
        // Calculando o percentual de participação do peso realizado
        this.entityLancamento.pesoRealizadoPercProjetadoSemestre2 = calcularPesoRealizadoPerc(this.entityLancamento.pesoRealizadoSemestre2, this.entityLancamento.pesoProjetadoSemestre2);
        // Calcular o percentual de evolução da peso projetado
        this.entityLancamento.pesoProjetadoPercEvolucaoSemestre2 = calcularPercEvolucao(this.entityLancamento.pesoRealizadoSemestre2AnoAnterior1, this.entityLancamento.pesoProjetadoSemestre2);
    }

    /** Altera o valor projetado do semestre 1 */
    private changeValorProjetadoSemestre1(valorProjetadoSemestre1: number) {
        // Setando o valor projetado
        this.entityLancamento.valorProjetadoSemestre1 = valorProjetadoSemestre1;
        // Calculando o percentual de participação do valor projetado
        this.entityLancamento.valorProjetadoPercSemestre1 = calcularValorProjetadoPerc(this.entityLancamento.valorProjetadoSemestre1, this.entityLancamento.valorPotencialSemestre1);
        // Calculando o percentual de participação do valor realizado
        this.entityLancamento.valorRealizadoPercProjetadoSemestre1 = calcularValorRealizadoPerc(this.entityLancamento.valorRealizadoSemestre1, this.entityLancamento.valorProjetadoSemestre1);
        // Calcular o percentual de evolução da valor projetado
        this.entityLancamento.valorProjetadoPercEvolucaoSemestre1 = calcularPercEvolucao(this.entityLancamento.valorRealizadoSemestre1AnoAnterior1, this.entityLancamento.valorProjetadoSemestre1);
    }
    /** Altera o valor projetado do semestre 2 */
    private changeValorProjetadoSemestre2(valorProjetadoSemestre2: number) {
        // Setando o valor projetado
        this.entityLancamento.valorProjetadoSemestre2 = valorProjetadoSemestre2;
        // Calculando o percentual de participação do valor projetado
        this.entityLancamento.valorProjetadoPercSemestre2 = calcularValorProjetadoPerc(this.entityLancamento.valorProjetadoSemestre2, this.entityLancamento.valorPotencialSemestre2);
        // Calculando o percentual de participação do valor realizado
        this.entityLancamento.valorRealizadoPercProjetadoSemestre2 = calcularValorRealizadoPerc(this.entityLancamento.valorRealizadoSemestre2, this.entityLancamento.valorProjetadoSemestre2);
        // Calcular o percentual de evolução da valor projetado
        this.entityLancamento.valorProjetadoPercEvolucaoSemestre2 = calcularPercEvolucao(this.entityLancamento.valorRealizadoSemestre2AnoAnterior1, this.entityLancamento.valorProjetadoSemestre2);
    }

    /** Mensal */

    /** Verifica se pode editar o lançamento por quantidade e periodicidade mensal */
    canEditLancamentoQuantidadeMensal(): boolean {
        // Se puder editar e o lançamento for por quantidade e a periodicidade for mensal
        return this.canEdit && this.isLancamentoQuantidade() && this.isPeriodicidadeMensal()
    }

    /** Verifica se pode editar o lançamento por peso e periodicidade mensal */
    canEditLancamentoPesoMensal(): boolean {
        // Se puder editar e o lançamento for por peso e a periodicidade for mensal
        return this.canEdit && this.isLancamentoPeso() && this.isPeriodicidadeMensal()
    }

    /** Verifica se pode editar o lançamento por valor e periodicidade mensal */
    canEditLancamentoValorMensal(): boolean {
        // Se puder editar e o lançamento for por valor e a periodicidade for mensal
        return this.canEdit && this.isLancamentoValor() && this.isPeriodicidadeMensal()
    }


    /** Verifica se o valor unitário é obrigatório ser informado quando o lançamento for por quantidade a periodicidade mensal */
    isQuantidadePretendidaValorUnitarioMesRequired(entityMes: ClienteAnaliseMercadoLancamentoMes): boolean {
        // Se não o lançamento for por quantidade então não é obrigatório
        if (!this.isLancamentoQuantidade()) {
            return false;
        }
        // Se não solicitar o preço médio então não é obrigatório
        if (!this.entityLancamento?.solicitarPrecoMedio) {
            return false;
        }
        // Se não for a periodicidade mensal, então não é obrigatório
        if (!this.isPeriodicidadeMensal()) {
            return false;
        }

        // Se possuir a quantidade potencial informada é obrigatório
        if ( (this.configAnaliseMercado?.solicitarPotencial) && (entityMes.quantidadePotencial !== null && entityMes.quantidadePotencial !== undefined) ) {
            return true;
        }
        // Se possuir a quantidade pretendida informada é obrigatório
        if (entityMes.quantidadePretendida !== null && entityMes.quantidadePretendida !== undefined) {
            return true;
        }

        return false;
    }

    /** Ao alterar o valor unitário quando o lançamento for por quantidade e periodicidade mensal */
    onChangeQuantidadePretendidaValorUnitarioMes(entityMes: ClienteAnaliseMercadoLancamentoMes, quantidadePretendidaValorUnitario: number) {
        entityMes.quantidadePretendidaValorUnitario = quantidadePretendidaValorUnitario;

        // Calculando o valor potencial no mês
        const valorPotencial = calcularValorPotencial(entityMes.quantidadePotencial, entityMes.quantidadePretendidaValorUnitario);
        this.onChangeValorPotencialMes(entityMes, valorPotencial);

        // Calculando o valor pretendido no mês
        const valorPretendido = calcularValorPretendido(entityMes.quantidadePretendida, entityMes.quantidadePretendidaValorUnitario);
        this.onChangeValorPretendidoMes(entityMes, valorPretendido, false);

        // Setando o valor unitário projetado igual ao valor unitário pretendido
        this.onChangeQuantidadeProjetadaValorUnitarioMes(entityMes, entityMes.quantidadePretendidaValorUnitario);
    }

    /** Seta o valor unitário da quantidade pretendida nos 12 meses */
    private setQuantidadePretendidaValorUnitarioMeses(quantidadePretendidaValorUnitario: number) {
        this.entityLancamento.meses?.forEach(entityMes => {
            entityMes.quantidadePretendidaValorUnitario = quantidadePretendidaValorUnitario;

            // Calculando o valor potencial no mês
            const valorPotencial = calcularValorPotencial(entityMes.quantidadePotencial, entityMes.quantidadePretendidaValorUnitario);
            this.changeValorPotencialMes(entityMes, valorPotencial);

            // Calculando o valor pretendido no mês
            const valorPretendido = calcularValorPretendido(entityMes.quantidadePretendida, entityMes.quantidadePretendidaValorUnitario);
            this.changeValorPretendidoMes(entityMes, valorPretendido);
        });

        /** Calculando os totais do valor potencial */
        const totais = this.clienteAnaliseMercadoLancamentoMesCalculoService.calcularValorPotencialTotais(this.entityLancamento.meses);
        // Antual
        this.changeValorPotencialAnual(totais.valorPotencial);
        // Trimestral
        this.changeValorPotencialTrimestre1(totais.valorPotencialTrimestre1);
        this.changeValorPotencialTrimestre2(totais.valorPotencialTrimestre2);
        this.changeValorPotencialTrimestre3(totais.valorPotencialTrimestre3);
        this.changeValorPotencialTrimestre4(totais.valorPotencialTrimestre4);
        // Semestral
        this.changeValorPotencialSemestre1(totais.valorPotencialSemestre1);
        this.changeValorPotencialSemestre2(totais.valorPotencialSemestre2);

        /** Calculando os totais do valor pretendido */
        const totaisPretendido = this.clienteAnaliseMercadoLancamentoMesCalculoService.calcularValorPretendidoTotais(this.entityLancamento.meses);
        // Anual
        this.changeValorPretendidoAnual(totaisPretendido.valorPretendido);
        // Trimestral
        this.changeValorPretendidoTrimestre1(totaisPretendido.valorPretendidoTrimestre1);
        this.changeValorPretendidoTrimestre2(totaisPretendido.valorPretendidoTrimestre2);
        this.changeValorPretendidoTrimestre3(totaisPretendido.valorPretendidoTrimestre3);
        this.changeValorPretendidoTrimestre4(totaisPretendido.valorPretendidoTrimestre4);
        // Semestral
        this.changeValorPretendidoSemestre1(totaisPretendido.valorPretendidoSemestre1);
        this.changeValorPretendidoSemestre2(totaisPretendido.valorPretendidoSemestre2);
    }

    /** Ao alterar o valor unitário projetado quando o lançamento for por quantidade e periodicidade mensal */
    private onChangeQuantidadeProjetadaValorUnitarioMes(entityMes: ClienteAnaliseMercadoLancamentoMes, quantidadeProjetadaValorUnitario: number) {
        entityMes.quantidadeProjetadaValorUnitario = quantidadeProjetadaValorUnitario;

        // Calculando o valor projetado no mês
        const valorProjetado = calcularValorProjetado(entityMes.quantidadeProjetada, entityMes.quantidadeProjetadaValorUnitario);
        this.onChangeValorProjetadoMes(entityMes, valorProjetado);
    }

    /** Seta o valor unitário da quantidade projetada nos 12 meses */
    private setQuantidadeProjetadaValorUnitarioMeses(quantidadeProjetadaValorUnitario: number) {
        this.entityLancamento.meses?.forEach(entityMes => {
            entityMes.quantidadeProjetadaValorUnitario = quantidadeProjetadaValorUnitario;

            // Calculando o valor projetado no mês
            const valorProjetado = calcularValorProjetado(entityMes.quantidadeProjetada, entityMes.quantidadeProjetadaValorUnitario);
            this.changeValorProjetadoMes(entityMes, valorProjetado)
        });

        /** Calculando os totais do valor projetado */
        const totais = this.clienteAnaliseMercadoLancamentoMesCalculoService.calcularValorProjetadoTotais(this.entityLancamento.meses);
        // Anual
        this.changeValorProjetadoAnual(totais.valorProjetado);
        // Trimestral
        this.changeValorProjetadoTrimestre1(totais.valorProjetadoTrimestre1);
        this.changeValorProjetadoTrimestre2(totais.valorProjetadoTrimestre2);
        this.changeValorProjetadoTrimestre3(totais.valorProjetadoTrimestre3);
        this.changeValorProjetadoTrimestre4(totais.valorProjetadoTrimestre4);
        // Semestral
        this.changeValorProjetadoSemestre1(totais.valorProjetadoSemestre1);
        this.changeValorProjetadoSemestre2(totais.valorProjetadoSemestre2);
    }

    /** Verifica se o valor unitário é obrigatório ser informado quando o lançamento for por peso a periodicidade mensal */
    isPesoPretendidoValorUnitarioMesRequired(entityMes: ClienteAnaliseMercadoLancamentoMes): boolean {
        // Se não o lançamento for por peso então não é obrigatório
        if (!this.isLancamentoPeso()) {
            return false;
        }
        // Se não solicitar o preço médio então não é obrigatório
        if (!this.entityLancamento?.solicitarPrecoMedio) {
            return false;
        }
        // Se não for a periodicidade mensal, então não é obrigatório
        if (!this.isPeriodicidadeMensal()) {
            return false;
        }

        // Se possuir o peso potencial informado é obrigatório
        if ( (this.configAnaliseMercado?.solicitarPotencial) && (entityMes.pesoPotencial !== null && entityMes.pesoPotencial !== undefined) ) {
            return true;
        }
        // Se possuir o peso pretendido informado é obrigatório
        if (entityMes.pesoPretendido !== null && entityMes.pesoPretendido !== undefined) {
            return true;
        }

        return false;
    }

    /** Ao alterar o valor unitário quando o lançamento for por peso e periodicidade mensal */
    onChangePesoPretendidoValorUnitarioMes(entityMes: ClienteAnaliseMercadoLancamentoMes, pesoPretendidoValorUnitario: number) {
        // Setando o valor unitário pretendido
        entityMes.pesoPretendidoValorUnitario = pesoPretendidoValorUnitario;

        // Calculando o valor potencial no mês
        const valorPotencial = calcularValorPotencial(entityMes.pesoPotencial, entityMes.pesoPretendidoValorUnitario);
        this.onChangeValorPotencialMes(entityMes, valorPotencial);

        // Calculando o valor pretendido no mês
        const valorPretendido = calcularValorPretendido(entityMes.pesoPretendido, entityMes.pesoPretendidoValorUnitario);
        this.onChangeValorPretendidoMes(entityMes, valorPretendido, false);

        // Setando o valor unitário projetado igual ao valor unitário pretendido
        this.onChangePesoProjetadoValorUnitarioMes(entityMes, entityMes.pesoPretendidoValorUnitario);
    }

    /** Seta o valor unitário do peso pretendido nos 12 meses */
    private setPesoPretendidoValorUnitarioMeses(pesoPretendidoValorUnitario: number) {
        this.entityLancamento.meses?.forEach(entityMes => {
            // Setando o valor unitário pretendido
            entityMes.pesoPretendidoValorUnitario = pesoPretendidoValorUnitario;

            // Calculando o valor potencial no mês
            const valorPotencial = calcularValorPotencial(entityMes.pesoPotencial, entityMes.pesoPretendidoValorUnitario);
            this.changeValorPotencialMes(entityMes, valorPotencial);

            // Calculando o valor pretendido no mês
            const valorPretendido = calcularValorPretendido(entityMes.pesoPretendido, entityMes.pesoPretendidoValorUnitario);
            this.changeValorPretendidoMes(entityMes, valorPretendido);
        });

        /** Calculando os totais do valor potencial */
        const totais = this.clienteAnaliseMercadoLancamentoMesCalculoService.calcularValorPotencialTotais(this.entityLancamento.meses);
        // Antual
        this.changeValorPotencialAnual(totais.valorPotencial);
        // Trimestral
        this.changeValorPotencialTrimestre1(totais.valorPotencialTrimestre1);
        this.changeValorPotencialTrimestre2(totais.valorPotencialTrimestre2);
        this.changeValorPotencialTrimestre3(totais.valorPotencialTrimestre3);
        this.changeValorPotencialTrimestre4(totais.valorPotencialTrimestre4);
        // Semestral
        this.changeValorPotencialSemestre1(totais.valorPotencialSemestre1);
        this.changeValorPotencialSemestre2(totais.valorPotencialSemestre2);

        /** Calculando os totais do valor pretendido */
        const totaisPretendido = this.clienteAnaliseMercadoLancamentoMesCalculoService.calcularValorPretendidoTotais(this.entityLancamento.meses);
        // Anual
        this.changeValorPretendidoAnual(totaisPretendido.valorPretendido);
        // Trimestral
        this.changeValorPretendidoTrimestre1(totaisPretendido.valorPretendidoTrimestre1);
        this.changeValorPretendidoTrimestre2(totaisPretendido.valorPretendidoTrimestre2);
        this.changeValorPretendidoTrimestre3(totaisPretendido.valorPretendidoTrimestre3);
        this.changeValorPretendidoTrimestre4(totaisPretendido.valorPretendidoTrimestre4);
        // Semestral
        this.changeValorPretendidoSemestre1(totaisPretendido.valorPretendidoSemestre1);
        this.changeValorPretendidoSemestre2(totaisPretendido.valorPretendidoSemestre2);
    }

    /** Ao alterar o valor unitário projetado quando o lançamento for por peso e periodicidade mensal */
    private onChangePesoProjetadoValorUnitarioMes(entityMes: ClienteAnaliseMercadoLancamentoMes, pesoProjetadoValorUnitario: number) {
        entityMes.pesoProjetadoValorUnitario = pesoProjetadoValorUnitario;

        // Calculando o valor projetado no mês
        const valorProjetado = calcularValorProjetado(entityMes.pesoProjetado, entityMes.pesoProjetadoValorUnitario);
        this.onChangeValorProjetadoMes(entityMes, valorProjetado);
    }

    /** Seta o valor unitário do peso projetado nos 12 meses */
    private setPesoProjetadoValorUnitarioMeses(pesoProjetadoValorUnitario: number) {
        this.entityLancamento.meses?.forEach(entityMes => {
            entityMes.pesoProjetadoValorUnitario = pesoProjetadoValorUnitario;

            // Calculando o valor projetado no mês
            const valorProjetado = calcularValorProjetado(entityMes.pesoProjetado, entityMes.pesoProjetadoValorUnitario);
            this.changeValorProjetadoMes(entityMes, valorProjetado);
        });

        /** Calculando os totais do valor projetado */
        const totais = this.clienteAnaliseMercadoLancamentoMesCalculoService.calcularValorProjetadoTotais(this.entityLancamento.meses);
        // Anual
        this.changeValorProjetadoAnual(totais.valorProjetado);
        // Trimestral
        this.changeValorProjetadoTrimestre1(totais.valorProjetadoTrimestre1);
        this.changeValorProjetadoTrimestre2(totais.valorProjetadoTrimestre2);
        this.changeValorProjetadoTrimestre3(totais.valorProjetadoTrimestre3);
        this.changeValorProjetadoTrimestre4(totais.valorProjetadoTrimestre4);
        // Semestral
        this.changeValorProjetadoSemestre1(totais.valorProjetadoSemestre1);
        this.changeValorProjetadoSemestre2(totais.valorProjetadoSemestre2);
    }

    /** Ao alterar a quantidade potencial do mês */
    onChangeQuantidadePotencialMes(entityMes: ClienteAnaliseMercadoLancamentoMes, quantidadePotencial: number) {
        this.changeQuantidadePotencialMes(entityMes, quantidadePotencial);

        /**  Calculando os totais da quantidade potencial **/
        const totais = this.clienteAnaliseMercadoLancamentoMesCalculoService.calcularQuantidadePotencialTotais(this.entityLancamento.meses);
        // Anual
        this.changeQuantidadePotencialAnual(totais.quantidadePotencial);
        // Trimestral
        this.changeQuantidadePotencialTrimestre1(totais.quantidadePotencialTrimestre1);
        this.changeQuantidadePotencialTrimestre2(totais.quantidadePotencialTrimestre2);
        this.changeQuantidadePotencialTrimestre3(totais.quantidadePotencialTrimestre3);
        this.changeQuantidadePotencialTrimestre4(totais.quantidadePotencialTrimestre4);
        // Semestral
        this.changeQuantidadePotencialSemestre1(totais.quantidadePotencialSemestre1);
        this.changeQuantidadePotencialSemestre2(totais.quantidadePotencialSemestre2);

        // Calculando o valor potencial no mês
        const valorPotencial = calcularValorPotencial(entityMes.quantidadePotencial, entityMes.quantidadePretendidaValorUnitario);
        this.onChangeValorPotencialMes(entityMes, valorPotencial);
    }

    /** Seta a quantidade potencial média mensal nos 12 meses */
    private setQuantidadePotencialMediaMensalMeses() {
        this.entityLancamento.meses?.forEach(entityMes => {
            this.changeQuantidadePotencialMes(entityMes, this.entityLancamento.quantidadePotencialMediaMensal);
        });

        /**  Calculando os totais da quantidade potencial **/
        const totais = this.clienteAnaliseMercadoLancamentoMesCalculoService.calcularQuantidadePotencialTotais(this.entityLancamento.meses);
        // Trimestral
        this.changeQuantidadePotencialTrimestre1(totais.quantidadePotencialTrimestre1);
        this.changeQuantidadePotencialTrimestre2(totais.quantidadePotencialTrimestre2);
        this.changeQuantidadePotencialTrimestre3(totais.quantidadePotencialTrimestre3);
        this.changeQuantidadePotencialTrimestre4(totais.quantidadePotencialTrimestre4);
        // Semestral
        this.changeQuantidadePotencialSemestre1(totais.quantidadePotencialSemestre1);
        this.changeQuantidadePotencialSemestre2(totais.quantidadePotencialSemestre2);
    }

    private changeQuantidadePotencialMes(entityMes: ClienteAnaliseMercadoLancamentoMes, quantidadePotencial: number) {
        entityMes.quantidadePotencial = quantidadePotencial;
        // Calculando o percentual de participação da quantidade pretendida sobre a quantidade potencial no mês
        entityMes.quantidadePretendidaPerc = calcularQuantidadePretendidaPerc(entityMes.quantidadePretendida, entityMes.quantidadePotencial);
        // Calculando o percentual de participação da quantidade projetada sobre a quantidade potencial no mês
        entityMes.quantidadeProjetadaPerc = calcularQuantidadeProjetadaPerc(entityMes.quantidadeProjetada, entityMes.quantidadePotencial);
        // Obtendo o status pretendido
        entityMes.statusPretendido = this.clienteAnaliseMercadoStatusPretendidoService.getStatusPretendido(entityMes.quantidadePotencial, entityMes.pesoPotencial, entityMes.valorPotencial, entityMes.quantidadePretendida, entityMes.pesoPretendido, entityMes.valorPretendido, entityMes.quantidadeRealizada, entityMes.pesoRealizado, entityMes.valorRealizado);
        // Obtendo o status projetado
        entityMes.statusProjetado = this.clienteAnaliseMercadoStatusProjetadoService.getStatusProjetado(entityMes.statusProjetado, entityMes.quantidadeProjetada, entityMes.pesoProjetado, entityMes.valorProjetado, entityMes.quantidadeRealizada, entityMes.pesoRealizado, entityMes.valorRealizado);
    }

    onChangePesoPotencialMes(entityMes: ClienteAnaliseMercadoLancamentoMes, pesoPotencial: number) {
        this.changePesoPotencialMes(entityMes, pesoPotencial);

        /**  Calculando os totais do peso potencial **/
        const totais = this.clienteAnaliseMercadoLancamentoMesCalculoService.calcularPesoPotencialTotais(this.entityLancamento.meses);
        // Anual
        this.changePesoPotencialAnual(totais.pesoPotencial);
        // Trimestral
        this.changePesoPotencialTrimestre1(totais.pesoPotencialTrimestre1);
        this.changePesoPotencialTrimestre2(totais.pesoPotencialTrimestre2);
        this.changePesoPotencialTrimestre3(totais.pesoPotencialTrimestre3);
        this.changePesoPotencialTrimestre4(totais.pesoPotencialTrimestre4);
        // Semestral
        this.changePesoPotencialSemestre1(totais.pesoPotencialSemestre1);
        this.changePesoPotencialSemestre2(totais.pesoPotencialSemestre2);

        // Calculando o valor potencial no mês
        const valorPotencial = calcularValorPotencial(entityMes.pesoPotencial, entityMes.pesoPretendidoValorUnitario);
        this.onChangeValorPotencialMes(entityMes, valorPotencial);
    }

    /** Seta o peso potencial médio mensal nos 12 meses */
    private setPesoPotencialMedioMensalMeses() {
        this.entityLancamento.meses?.forEach(entityMes => {
            this.changePesoPotencialMes(entityMes, this.entityLancamento.pesoPotencialMedioMensal);
        });

        /**  Calculando os totais do peso potencial **/
        const totais = this.clienteAnaliseMercadoLancamentoMesCalculoService.calcularPesoPotencialTotais(this.entityLancamento.meses);
        // Trimestral
        this.changePesoPotencialTrimestre1(totais.pesoPotencialTrimestre1);
        this.changePesoPotencialTrimestre2(totais.pesoPotencialTrimestre2);
        this.changePesoPotencialTrimestre3(totais.pesoPotencialTrimestre3);
        this.changePesoPotencialTrimestre4(totais.pesoPotencialTrimestre4);
        // Semestral
        this.changePesoPotencialSemestre1(totais.pesoPotencialSemestre1);
        this.changePesoPotencialSemestre2(totais.pesoPotencialSemestre2);
    }

    private changePesoPotencialMes(entityMes: ClienteAnaliseMercadoLancamentoMes, pesoPotencial: number) {
        entityMes.pesoPotencial = pesoPotencial;
        // Calculando o percentual de participação do peso pretendido sobre o peso potencial no mês
        entityMes.pesoPretendidoPerc = calcularPesoPretendidoPerc(entityMes.pesoPretendido, entityMes.pesoPotencial);
        // Calculando o percentual de participação do peso projetado sobre o peso potencial no mês
        entityMes.pesoProjetadoPerc = calcularPesoProjetadoPerc(entityMes.pesoProjetado, entityMes.pesoPotencial);
        // Obtendo o status pretendido
        entityMes.statusPretendido = this.clienteAnaliseMercadoStatusPretendidoService.getStatusPretendido(entityMes.quantidadePotencial, entityMes.pesoPotencial, entityMes.valorPotencial, entityMes.quantidadePretendida, entityMes.pesoPretendido, entityMes.valorPretendido, entityMes.quantidadeRealizada, entityMes.pesoRealizado, entityMes.valorRealizado);
        // Obtendo o status projetado
        entityMes.statusProjetado = this.clienteAnaliseMercadoStatusProjetadoService.getStatusProjetado(entityMes.statusProjetado, entityMes.quantidadeProjetada, entityMes.pesoProjetado, entityMes.valorProjetado, entityMes.quantidadeRealizada, entityMes.pesoRealizado, entityMes.valorRealizado);
    }


    onChangeValorPotencialMes(entityMes: ClienteAnaliseMercadoLancamentoMes, valorPotencial: number) {
        this.changeValorPotencialMes(entityMes, valorPotencial);

        /** Calculando os totais do valor potencial */
        const totais = this.clienteAnaliseMercadoLancamentoMesCalculoService.calcularValorPotencialTotais(this.entityLancamento.meses);
        // Antual
        this.changeValorPotencialAnual(totais.valorPotencial);
        // Trimestral
        this.changeValorPotencialTrimestre1(totais.valorPotencialTrimestre1);
        this.changeValorPotencialTrimestre2(totais.valorPotencialTrimestre2);
        this.changeValorPotencialTrimestre3(totais.valorPotencialTrimestre3);
        this.changeValorPotencialTrimestre4(totais.valorPotencialTrimestre4);
        // Semestral
        this.changeValorPotencialSemestre1(totais.valorPotencialSemestre1);
        this.changeValorPotencialSemestre2(totais.valorPotencialSemestre2);
    }

    /** Seta o valor potencial médio mensal nos 12 meses */
    private setValorPotencialMedioMensalMeses() {
        this.entityLancamento.meses?.forEach(entityMes => {
            this.changeValorPotencialMes(entityMes, this.entityLancamento.valorPotencialMedioMensal);
        });

        /** Calculando os totais do valor potencial */
        const totais = this.clienteAnaliseMercadoLancamentoMesCalculoService.calcularValorPotencialTotais(this.entityLancamento.meses);
        // Trimestral
        this.changeValorPotencialTrimestre1(totais.valorPotencialTrimestre1);
        this.changeValorPotencialTrimestre2(totais.valorPotencialTrimestre2);
        this.changeValorPotencialTrimestre3(totais.valorPotencialTrimestre3);
        this.changeValorPotencialTrimestre4(totais.valorPotencialTrimestre4);
        // Semestral
        this.changeValorPotencialSemestre1(totais.valorPotencialSemestre1);
        this.changeValorPotencialSemestre2(totais.valorPotencialSemestre2);
    }

    /** Calcula o Customer Share do mês informado */
    private calcularCustomerShareMes(entityMes: ClienteAnaliseMercadoLancamentoMes) {
        const customerShare = new CustomerShareValueObject(this.configCliente.customerShareOtimo, this.configCliente.customerShareBom, this.configCliente.customerShareRazoavel, entityMes.valorPotencial, entityMes.valorPretendido, entityMes.valorRealizado);
        // Pretendido
        entityMes.valorPretendidoPerc = customerShare.valorPretendidoPerc;
        entityMes.indicadorCustomerSharePretendido = customerShare.indicadorPretendido.id;
        // Realizado
        entityMes.indicadorCustomerShareRealizado = customerShare.indicadorRealizado.id;
    }

    private changeValorPotencialMes(entityMes: ClienteAnaliseMercadoLancamentoMes, valorPotencial: number) {
        entityMes.valorPotencial = valorPotencial;

        // Calculando o Customer Share no mês
        this.calcularCustomerShareMes(entityMes);

        // Calculando o percentual de participação do valor projetado sobre o valor potencial no mês
        entityMes.valorProjetadoPerc = calcularValorProjetadoPerc(entityMes.valorProjetado, entityMes.valorPotencial);
        // Obtendo o status pretendido
        entityMes.statusPretendido = this.clienteAnaliseMercadoStatusPretendidoService.getStatusPretendido(entityMes.quantidadePotencial, entityMes.pesoPotencial, entityMes.valorPotencial, entityMes.quantidadePretendida, entityMes.pesoPretendido, entityMes.valorPretendido, entityMes.quantidadeRealizada, entityMes.pesoRealizado, entityMes.valorRealizado);
        // Obtendo o status projetado
        entityMes.statusProjetado = this.clienteAnaliseMercadoStatusProjetadoService.getStatusProjetado(entityMes.statusProjetado, entityMes.quantidadeProjetada, entityMes.pesoProjetado, entityMes.valorProjetado, entityMes.quantidadeRealizada, entityMes.pesoRealizado, entityMes.valorRealizado);
    }

    onChangeQuantidadePretendidaMes(entityMes: ClienteAnaliseMercadoLancamentoMes, quantidadePretendida: number) {
        // Setando a quantidade pretendida no mês
        this.changeQuantidadePretendidaMes(entityMes, quantidadePretendida);

        /** Calcuando os totais da quantidade pretendida */
        const totaisPretendida = this.clienteAnaliseMercadoLancamentoMesCalculoService.calcularQuantidadePretendidaTotais(this.entityLancamento.meses);
        // Anual
        this.changeQuantidadePretendidaAnual(totaisPretendida.quantidadePretendida);
        // Trimestral
        this.changeQuantidadePretendidaTrimestre1(totaisPretendida.quantidadePretendidaTrimestre1);
        this.changeQuantidadePretendidaTrimestre2(totaisPretendida.quantidadePretendidaTrimestre2);
        this.changeQuantidadePretendidaTrimestre3(totaisPretendida.quantidadePretendidaTrimestre3);
        this.changeQuantidadePretendidaTrimestre4(totaisPretendida.quantidadePretendidaTrimestre4);
        // Semestral
        this.changeQuantidadePretendidaSemestre1(totaisPretendida.quantidadePretendidaSemestre1);
        this.changeQuantidadePretendidaSemestre2(totaisPretendida.quantidadePretendidaSemestre2);

        // Calculando o valor pretendido no mês
        const valorPretendido = calcularValorPretendido(entityMes.quantidadePretendida, entityMes.quantidadePretendidaValorUnitario);
        this.onChangeValorPretendidoMes(entityMes, valorPretendido, false);

        // Setando a quantidade projetada no mês igual a quantidade pretendida
        this.onChangeQuantidadeProjetadaMes(entityMes, quantidadePretendida);
    }

    /** Seta a quantidade pretendida média mensal nos 12 meses */
    private setQuantidadePretendidaMediaMensalMeses() {
        this.entityLancamento.meses?.forEach(entityMes => {
            this.changeQuantidadePretendidaMes(entityMes, this.entityLancamento.quantidadePretendidaMediaMensal);
        });

        /** Calcuando os totais da quantidade pretendida */
        const totais = this.clienteAnaliseMercadoLancamentoMesCalculoService.calcularQuantidadePretendidaTotais(this.entityLancamento.meses);
        // Trimestral
        this.changeQuantidadePretendidaTrimestre1(totais.quantidadePretendidaTrimestre1);
        this.changeQuantidadePretendidaTrimestre2(totais.quantidadePretendidaTrimestre2);
        this.changeQuantidadePretendidaTrimestre3(totais.quantidadePretendidaTrimestre3);
        this.changeQuantidadePretendidaTrimestre4(totais.quantidadePretendidaTrimestre4);
        // Semestral
        this.changeQuantidadePretendidaSemestre1(totais.quantidadePretendidaSemestre1);
        this.changeQuantidadePretendidaSemestre2(totais.quantidadePretendidaSemestre2);
    }

    private changeQuantidadePretendidaMes(entityMes: ClienteAnaliseMercadoLancamentoMes, quantidadePretendida: number) {
        entityMes.quantidadePretendida = quantidadePretendida;
        // Calculando o percentual de participação da quantidade pretendida sobre a quantidade potencial no mês
        entityMes.quantidadePretendidaPerc = calcularQuantidadePretendidaPerc(entityMes.quantidadePretendida, entityMes.quantidadePotencial);
        // Calculando o percentual de participação da quantidade realizada sobre a quantidade projetada no mês
        entityMes.quantidadeRealizadaPercPretendida = calcularQuantidadeRealizadaPerc(entityMes.quantidadeRealizada, entityMes.quantidadePretendida);
        // Calcular o percentual de evolução da quantidade pretendida
        entityMes.quantidadePretendidaPercEvolucao = calcularPercEvolucao(entityMes.quantidadeRealizadaAnoAnterior1, entityMes.quantidadePretendida);
        // Obtendo o status pretendido
        entityMes.statusPretendido = this.clienteAnaliseMercadoStatusPretendidoService.getStatusPretendido(entityMes.quantidadePotencial, entityMes.pesoPotencial, entityMes.valorPotencial, entityMes.quantidadePretendida, entityMes.pesoPretendido, entityMes.valorPretendido, entityMes.quantidadeRealizada, entityMes.pesoRealizado, entityMes.valorRealizado);
    }

    /** Ao alterar o percentual da quantidade pretendida mensal */
    onChangeQuantidadePretendidaPercMes(entityMes: ClienteAnaliseMercadoLancamentoMes, quantidadePretendidaPerc: number) {
        // Calculando a participação da quantidade pretendida sobre a quantidade potencial
        const quantidadePretendida = calcularParticipacaoQuantidadePretendida(entityMes.quantidadePotencial, quantidadePretendidaPerc);
        // Delegando para o método de alteração da quantidade pretendida mensal realizar os demais cálculos
        this.onChangeQuantidadePretendidaMes(entityMes, quantidadePretendida);
    }

    private onChangeQuantidadeProjetadaMes(entityMes: ClienteAnaliseMercadoLancamentoMes, quantidadeProjetada: number) {
        // Setando a quantidade projetada no mês
        this.changeQuantidadeProjetadaMes(entityMes, quantidadeProjetada);

        /** Calculando os totais da quantidade projetada */
        const totais = this.clienteAnaliseMercadoLancamentoMesCalculoService.calcularQuantidadeProjetadaTotais(this.entityLancamento.meses);
        // Anual
        this.changeQuantidadeProjetadaAnual(totais.quantidadeProjetada);
        // Trimestral
        this.changeQuantidadeProjetadaTrimestre1(totais.quantidadeProjetadaTrimestre1);
        this.changeQuantidadeProjetadaTrimestre2(totais.quantidadeProjetadaTrimestre2);
        this.changeQuantidadeProjetadaTrimestre3(totais.quantidadeProjetadaTrimestre3);
        this.changeQuantidadeProjetadaTrimestre4(totais.quantidadeProjetadaTrimestre4);
        // Semestral
        this.changeQuantidadeProjetadaSemestre1(totais.quantidadeProjetadaSemestre1);
        this.changeQuantidadeProjetadaSemestre2(totais.quantidadeProjetadaSemestre2);

        // Calculando o valor projetado no mês
        const valorProjetado = calcularValorProjetado(entityMes.quantidadeProjetada, entityMes.quantidadeProjetadaValorUnitario);
        this.onChangeValorProjetadoMes(entityMes, valorProjetado);
    }

    /** Seta a quantidade projetada média mensal nos 12 meses */
    private setQuantidadeProjetadaMediaMensalMeses() {
        this.entityLancamento.meses?.forEach(entityMes => {
            this.changeQuantidadeProjetadaMes(entityMes, this.entityLancamento.quantidadeProjetadaMediaMensal);
        });

        /** Calculando os totais da quantidade projetada */
        const totais = this.clienteAnaliseMercadoLancamentoMesCalculoService.calcularQuantidadeProjetadaTotais(this.entityLancamento.meses);
        // Trimestral
        this.changeQuantidadeProjetadaTrimestre1(totais.quantidadeProjetadaTrimestre1);
        this.changeQuantidadeProjetadaTrimestre2(totais.quantidadeProjetadaTrimestre2);
        this.changeQuantidadeProjetadaTrimestre3(totais.quantidadeProjetadaTrimestre3);
        this.changeQuantidadeProjetadaTrimestre4(totais.quantidadeProjetadaTrimestre4);
        // Semestral
        this.changeQuantidadeProjetadaSemestre1(totais.quantidadeProjetadaSemestre1);
        this.changeQuantidadeProjetadaSemestre2(totais.quantidadeProjetadaSemestre2);
    }

    private changeQuantidadeProjetadaMes(entityMes: ClienteAnaliseMercadoLancamentoMes, quantidadeProjetada: number) {
        entityMes.quantidadeProjetada = quantidadeProjetada;
        // Calculando o percentual de participação da quantidade projetada sobre a quantidade potencial no mês
        entityMes.quantidadeProjetadaPerc = calcularQuantidadeProjetadaPerc(entityMes.quantidadeProjetada, entityMes.quantidadePotencial);
        // Calculando o percentual de participação da quantidade realizada sobre a quantidade projetada no mês
        entityMes.quantidadeRealizadaPercProjetada = calcularQuantidadeRealizadaPerc(entityMes.quantidadeRealizada, entityMes.quantidadeProjetada);
        // Calcular o percentual de evolução da quantidade projetada
        entityMes.quantidadeProjetadaPercEvolucao = calcularPercEvolucao(entityMes.quantidadeRealizadaAnoAnterior1, entityMes.quantidadeProjetada);
        // Obtendo o status projetado
        entityMes.statusProjetado = this.clienteAnaliseMercadoStatusProjetadoService.getStatusProjetado(entityMes.statusProjetado, entityMes.quantidadeProjetada, entityMes.pesoProjetado, entityMes.valorProjetado, entityMes.quantidadeRealizada, entityMes.pesoRealizado, entityMes.valorRealizado);
    }

    onChangePesoPretendidoMes(entityMes: ClienteAnaliseMercadoLancamentoMes, pesoPretendido: number) {
        // Setando o peso pretendido no mês
        this.changePesoPretendidoMes(entityMes, pesoPretendido);

        /** Calcuando os totais do peso pretendido */
        const totaisPretendido = this.clienteAnaliseMercadoLancamentoMesCalculoService.calcularPesoPretendidoTotais(this.entityLancamento.meses);
        // Anual
        this.changePesoPretendidoAnual(totaisPretendido.pesoPretendido);
        // Trimestral
        this.changePesoPretendidoTrimestre1(totaisPretendido.pesoPretendidoTrimestre1);
        this.changePesoPretendidoTrimestre2(totaisPretendido.pesoPretendidoTrimestre2);
        this.changePesoPretendidoTrimestre3(totaisPretendido.pesoPretendidoTrimestre3);
        this.changePesoPretendidoTrimestre4(totaisPretendido.pesoPretendidoTrimestre4);
        // Semestral
        this.changePesoPretendidoSemestre1(totaisPretendido.pesoPretendidoSemestre1);
        this.changePesoPretendidoSemestre2(totaisPretendido.pesoPretendidoSemestre2);

        // Calculando o valor pretendido no mês
        const valorPretendido = calcularValorPretendido(entityMes.pesoPretendido, entityMes.pesoPretendidoValorUnitario);
        this.onChangeValorPretendidoMes(entityMes, valorPretendido, false);

        // Setando o peso projetado no mês igual o peso pretendido
        this.onChangePesoProjetadoMes(entityMes, pesoPretendido);
    }

    /** Seta o peso pretendido médio mensal nos 12 meses */
    private setPesoPretendidoMedioMensalMeses() {
        this.entityLancamento.meses?.forEach(entityMes => {
            this.changePesoPretendidoMes(entityMes, this.entityLancamento.pesoPretendidoMedioMensal);
        });

        /** Calcuando os totais do peso pretendido */
        const totais = this.clienteAnaliseMercadoLancamentoMesCalculoService.calcularPesoPretendidoTotais(this.entityLancamento.meses);
        // Trimestral
        this.changePesoPretendidoTrimestre1(totais.pesoPretendidoTrimestre1);
        this.changePesoPretendidoTrimestre2(totais.pesoPretendidoTrimestre2);
        this.changePesoPretendidoTrimestre3(totais.pesoPretendidoTrimestre3);
        this.changePesoPretendidoTrimestre4(totais.pesoPretendidoTrimestre4);
        // Semestral
        this.changePesoPretendidoSemestre1(totais.pesoPretendidoSemestre1);
        this.changePesoPretendidoSemestre2(totais.pesoPretendidoSemestre2);
    }

    private changePesoPretendidoMes(entityMes: ClienteAnaliseMercadoLancamentoMes, pesoPretendido: number) {
        entityMes.pesoPretendido = pesoPretendido;
        // Calculando o percentual de participação do peso pretendido sobre o peso potencial no mês
        entityMes.pesoPretendidoPerc = calcularPesoPretendidoPerc(entityMes.pesoPretendido, entityMes.pesoPotencial);
        // Calculando o percentual de participação do peso realizado sobre o peso pretendido no mês
        entityMes.pesoRealizadoPercPretendido = calcularPesoRealizadoPerc(entityMes.pesoRealizado, entityMes.pesoPretendido);
        // Calcular o percentual de evolução da peso pretendido
        entityMes.pesoPretendidoPercEvolucao = calcularPercEvolucao(entityMes.pesoRealizadoAnoAnterior1, entityMes.pesoPretendido);
        // Obtendo o status pretendido
        entityMes.statusPretendido = this.clienteAnaliseMercadoStatusPretendidoService.getStatusPretendido(entityMes.quantidadePotencial, entityMes.pesoPotencial, entityMes.valorPotencial, entityMes.quantidadePretendida, entityMes.pesoPretendido, entityMes.valorPretendido, entityMes.quantidadeRealizada, entityMes.pesoRealizado, entityMes.valorRealizado);
    }

    /** Ao alterar o percentual do peso pretendido mensal */
    onChangePesoPretendidoPercMes(entityMes: ClienteAnaliseMercadoLancamentoMes, pesoPretendidoPerc: number) {
        // Calculando a participação do peso pretendido sobre o peso potencial
        const pesoPretendido = calcularParticipacaoPesoPretendido(entityMes.pesoPotencial, pesoPretendidoPerc);
        // Delegando para o método de alteração do peso pretendido mensal realizar os demais cálculos
        this.onChangePesoPretendidoMes(entityMes, pesoPretendido);
    }

    private onChangePesoProjetadoMes(entityMes: ClienteAnaliseMercadoLancamentoMes, pesoProjetado: number) {
        // Setando o peso projetado no mês
        this.changePesoProjetadoMes(entityMes, pesoProjetado);

        /** Calculando os totais do peso projetado */
        const totais = this.clienteAnaliseMercadoLancamentoMesCalculoService.calcularPesoProjetadoTotais(this.entityLancamento.meses);
        // Anual
        this.changePesoProjetadoAnual(totais.pesoProjetado);
        // Trimestral
        this.changePesoProjetadoTrimestre1(totais.pesoProjetadoTrimestre1);
        this.changePesoProjetadoTrimestre2(totais.pesoProjetadoTrimestre2);
        this.changePesoProjetadoTrimestre3(totais.pesoProjetadoTrimestre3);
        this.changePesoProjetadoTrimestre4(totais.pesoProjetadoTrimestre4);
        // Semestral
        this.changePesoProjetadoSemestre1(totais.pesoProjetadoSemestre1);
        this.changePesoProjetadoSemestre2(totais.pesoProjetadoSemestre2);

        // Calculando o valor projetado no mês
        const valorProjetado = calcularValorProjetado(entityMes.pesoProjetado, entityMes.pesoProjetadoValorUnitario);
        this.onChangeValorProjetadoMes(entityMes, valorProjetado);
    }

    /** Seta o peso projetado médio mensal nos 12 meses */
    private setPesoProjetadoMedioMensalMeses() {
        this.entityLancamento.meses?.forEach(entityMes => {
            this.changePesoProjetadoMes(entityMes, this.entityLancamento.pesoProjetadoMedioMensal);
        });

        /** Calculando os totais do peso projetado */
        const totais = this.clienteAnaliseMercadoLancamentoMesCalculoService.calcularPesoProjetadoTotais(this.entityLancamento.meses);
        // Trimestral
        this.changePesoProjetadoTrimestre1(totais.pesoProjetadoTrimestre1);
        this.changePesoProjetadoTrimestre2(totais.pesoProjetadoTrimestre2);
        this.changePesoProjetadoTrimestre3(totais.pesoProjetadoTrimestre3);
        this.changePesoProjetadoTrimestre4(totais.pesoProjetadoTrimestre4);
        // Semestral
        this.changePesoProjetadoSemestre1(totais.pesoProjetadoSemestre1);
        this.changePesoProjetadoSemestre2(totais.pesoProjetadoSemestre2);
    }

    private changePesoProjetadoMes(entityMes: ClienteAnaliseMercadoLancamentoMes, pesoProjetado: number) {
        entityMes.pesoProjetado = pesoProjetado;
        // Calculando o percentual de participação do peso projetado sobre o peso potencial no mês
        entityMes.pesoProjetadoPerc = calcularPesoProjetadoPerc(entityMes.pesoProjetado, entityMes.pesoPotencial);
        // Calculando o percentual de participação do peso realizado sobre o peso projetado no mês
        entityMes.pesoRealizadoPercProjetado = calcularPesoRealizadoPerc(entityMes.pesoRealizado, entityMes.pesoProjetado);
        // Calcular o percentual de evolução da peso projetado
        entityMes.pesoProjetadoPercEvolucao = calcularPercEvolucao(entityMes.pesoRealizadoAnoAnterior1, entityMes.pesoProjetado);
        // Obtendo o status projetado
        entityMes.statusProjetado = this.clienteAnaliseMercadoStatusProjetadoService.getStatusProjetado(entityMes.statusProjetado, entityMes.quantidadeProjetada, entityMes.pesoProjetado, entityMes.valorProjetado, entityMes.quantidadeRealizada, entityMes.pesoRealizado, entityMes.valorRealizado);
    }

    /** Ao alterar o valor pretendido mensal
     *
     * @param valorPretendido valor pretendido mensal
     * @param setValorProjetado se deve setar o valor projetado mensal igual ao valor pretendido mensal
     */
    onChangeValorPretendidoMes(entityMes: ClienteAnaliseMercadoLancamentoMes, valorPretendido: number, setValorProjetado: boolean) {
        // Setando o valor pretendido no mês
        this.changeValorPretendidoMes(entityMes, valorPretendido);

        /** Calculando os totais do valor pretendido */
        const totaisPretendido = this.clienteAnaliseMercadoLancamentoMesCalculoService.calcularValorPretendidoTotais(this.entityLancamento.meses);
        // Anual
        this.changeValorPretendidoAnual(totaisPretendido.valorPretendido);
        // Trimestral
        this.changeValorPretendidoTrimestre1(totaisPretendido.valorPretendidoTrimestre1);
        this.changeValorPretendidoTrimestre2(totaisPretendido.valorPretendidoTrimestre2);
        this.changeValorPretendidoTrimestre3(totaisPretendido.valorPretendidoTrimestre3);
        this.changeValorPretendidoTrimestre4(totaisPretendido.valorPretendidoTrimestre4);
        // Semestral
        this.changeValorPretendidoSemestre1(totaisPretendido.valorPretendidoSemestre1);
        this.changeValorPretendidoSemestre2(totaisPretendido.valorPretendidoSemestre2);


        // Setando o valor projetado no mês igual ao valor pretendido
        if (setValorProjetado) {
            this.onChangeValorProjetadoMes(entityMes, valorPretendido);
        }
    }

    /** Seta o valor pretendido médio mensal nos 12 meses **/
    private setValorPretendidoMedioMensalMeses() {
        this.entityLancamento.meses?.forEach(entityMes => {
            this.changeValorPretendidoMes(entityMes, this.entityLancamento.valorPretendidoMedioMensal);
        });

        /** Calculando os totais do valor pretendido */
        const totais = this.clienteAnaliseMercadoLancamentoMesCalculoService.calcularValorPretendidoTotais(this.entityLancamento.meses);
        // Trimestral
        this.changeValorPretendidoTrimestre1(totais.valorPretendidoTrimestre1);
        this.changeValorPretendidoTrimestre2(totais.valorPretendidoTrimestre2);
        this.changeValorPretendidoTrimestre3(totais.valorPretendidoTrimestre3);
        this.changeValorPretendidoTrimestre4(totais.valorPretendidoTrimestre4);
        // Semestral
        this.changeValorPretendidoSemestre1(totais.valorPretendidoSemestre1);
        this.changeValorPretendidoSemestre2(totais.valorPretendidoSemestre2);
    }

    private changeValorPretendidoMes(entityMes: ClienteAnaliseMercadoLancamentoMes, valorPretendido: number) {
        entityMes.valorPretendido = valorPretendido;

        // Calculando o Customer Share no mês
        this.calcularCustomerShareMes(entityMes);

        // Calculando o percentual de participação do valor realizado sobre o valor pretendido no mês
        entityMes.valorRealizadoPercPretendido = calcularValorRealizadoPerc(entityMes.valorRealizado, entityMes.valorPretendido);
        // Calcular o percentual de evolução da valor pretendido
        entityMes.valorPretendidoPercEvolucao = calcularPercEvolucao(entityMes.valorRealizadoAnoAnterior1, entityMes.valorPretendido);
        // Obtendo o status pretendido
        entityMes.statusPretendido = this.clienteAnaliseMercadoStatusPretendidoService.getStatusPretendido(entityMes.quantidadePotencial, entityMes.pesoPotencial, entityMes.valorPotencial, entityMes.quantidadePretendida, entityMes.pesoPretendido, entityMes.valorPretendido, entityMes.quantidadeRealizada, entityMes.pesoRealizado, entityMes.valorRealizado);
    }

    /** Ao alterar o percentual do valor pretendido mensal */
    onChangeValorPretendidoPercMes(entityMes: ClienteAnaliseMercadoLancamentoMes, valorPretendidoPerc: number) {
        // Calculando a participação do valor pretendido sobre o valor potencial
        const valorPretendido = calcularParticipacaoValorPretendido(entityMes.valorPotencial, valorPretendidoPerc);
        // Delegando para o método de alteração do valor pretendido mensal realizar os demais cálculos
        this.onChangeValorPretendidoMes(entityMes, valorPretendido, true);
    }

    private onChangeValorProjetadoMes(entityMes: ClienteAnaliseMercadoLancamentoMes, valorProjetado: number) {
        // Setando o valor projetado no mês
        this.changeValorProjetadoMes(entityMes, valorProjetado);

        /** Calculando os totais do valor projetado */
        const totais = this.clienteAnaliseMercadoLancamentoMesCalculoService.calcularValorProjetadoTotais(this.entityLancamento.meses);
        // Anual
        this.changeValorProjetadoAnual(totais.valorProjetado);
        // Trimestral
        this.changeValorProjetadoTrimestre1(totais.valorProjetadoTrimestre1);
        this.changeValorProjetadoTrimestre2(totais.valorProjetadoTrimestre2);
        this.changeValorProjetadoTrimestre3(totais.valorProjetadoTrimestre3);
        this.changeValorProjetadoTrimestre4(totais.valorProjetadoTrimestre4);
        // Semestral
        this.changeValorProjetadoSemestre1(totais.valorProjetadoSemestre1);
        this.changeValorProjetadoSemestre2(totais.valorProjetadoSemestre2);
    }

    /** Seta o valor projetado médio mensal nos 12 meses */
    private setValorProjetadoMedioMensalMeses() {
        this.entityLancamento.meses?.forEach(entityMes => {
            this.changeValorProjetadoMes(entityMes, this.entityLancamento.valorProjetadoMedioMensal);
        });

        /** Calculando os totais do valor projetado */
        const totais = this.clienteAnaliseMercadoLancamentoMesCalculoService.calcularValorProjetadoTotais(this.entityLancamento.meses);
        // Trimestral
        this.changeValorProjetadoTrimestre1(totais.valorProjetadoTrimestre1);
        this.changeValorProjetadoTrimestre2(totais.valorProjetadoTrimestre2);
        this.changeValorProjetadoTrimestre3(totais.valorProjetadoTrimestre3);
        this.changeValorProjetadoTrimestre4(totais.valorProjetadoTrimestre4);
        // Semestral
        this.changeValorProjetadoSemestre1(totais.valorProjetadoSemestre1);
        this.changeValorProjetadoSemestre2(totais.valorProjetadoSemestre2);
    }

    private changeValorProjetadoMes(entityMes: ClienteAnaliseMercadoLancamentoMes, valorProjetado: number) {
        entityMes.valorProjetado = valorProjetado;
        // Calculando o percentual de participação do valor projetado sobre o valor potencial no mês
        entityMes.valorProjetadoPerc = calcularValorProjetadoPerc(entityMes.valorProjetado, entityMes.valorPotencial);
        // Calculando o percentual de participação do valor realizado sobre o valor projetado no mês
        entityMes.valorRealizadoPercProjetado = calcularValorRealizadoPerc(entityMes.valorRealizado, entityMes.valorProjetado);
        // Calcular o percentual de evolução da valor projetado
        entityMes.valorProjetadoPercEvolucao = calcularPercEvolucao(entityMes.valorRealizadoAnoAnterior1, entityMes.valorProjetado);
        // Obtendo o status projetado
        entityMes.statusProjetado = this.clienteAnaliseMercadoStatusProjetadoService.getStatusProjetado(entityMes.statusProjetado, entityMes.quantidadeProjetada, entityMes.pesoProjetado, entityMes.valorProjetado, entityMes.quantidadeRealizada, entityMes.pesoRealizado, entityMes.valorRealizado);
    }

    /** Verifica se a anotação é obrigatória quando não possuir a quantidade pretendida anual */
    isAnotacaoRequiredSemQuantidadePretendida(): boolean {
        if (!this.entityLancamento) {
            return false;
        }
        if (!this.isLancamentoQuantidade()) {
            return false;
        }

        return !this.entityLancamento.quantidadePretendida || this.entityLancamento.quantidadePretendida === 0;
    }

    /** Verifica se a anotação é obrigatória quando não possuir o peso pretendido anual */
    isAnotacaoRequiredSemPesoPretendido(): boolean {
        if (!this.entityLancamento) {
            return false;
        }
        if (!this.isLancamentoPeso()) {
            return false;
        }

        return !this.entityLancamento.pesoPretendido || this.entityLancamento.pesoPretendido === 0;
    }

    /** Verifica se a anotação é obrigatória quando não possuir o valor pretendido anual */
    isAnotacaoRequiredSemValorPretendido(): boolean {
        if (!this.entityLancamento) {
            return false;
        }
        if (!this.isLancamentoValor()) {
            return false;
        }

        // Meta por Valor
        return !this.entityLancamento.valorPretendido || this.entityLancamento.valorPretendido === 0;
    }

    /** Valida o save das atualizações da análise de mercado da unidade de negócio no cliente */
    isValid(): boolean {
        // Validando se o valor unitário da quantidade pretendida não foi informado quando o lançamento for por quantidade e periodicidade anual
        if (this.isQuantidadePretendidaValorUnitarioAnualRequired() && (this.entityLancamento.quantidadePretendidaValorUnitario == null || this.entityLancamento.quantidadePretendidaValorUnitario === undefined)) {
            this.messageService.warning('Informe o preço médio anual ou remova a quantidade Sell In Cliente e pretendida', 'É obrigatório informar o preço médio anual', notCloseMessageOptions);
            this.quantidadePretendidaValorUnitarioDecimalAnual?.setFocus();
            return false;
        }
        // Validando se o valor unitário da quantidade pretendida não foi informado quando o lançamento for por quantidade e a periodicidade pela média mensal
        if (this.isQuantidadePretendidaValorUnitarioMediaMensalRequired() && (this.entityLancamento.quantidadePretendidaValorUnitario == null || this.entityLancamento.quantidadePretendidaValorUnitario === undefined)) {
            this.messageService.warning('Informe o preço médio na média mensal ou remova a quantidade Sell In Cliente e pretendida', 'É obrigatório informar o preço médio na média mensal', notCloseMessageOptions);
            this.quantidadePretendidaValorUnitarioDecimalMediaMensal?.setFocus();
            return false;
        }

        // Validando se o valor unitário do peso pretendido não foi informado quando o lançamento for por peso e periodicidade anual
        if (this.isPesoPretendidoValorUnitarioAnualRequired() && (this.entityLancamento.pesoPretendidoValorUnitario == null || this.entityLancamento.pesoPretendidoValorUnitario === undefined)) {
            this.messageService.warning('Informe o preço médio anual ou remova o peso Sell In Cliente e pretendida', 'É obrigatório informar o preço médio anual', notCloseMessageOptions);
            this.pesoPretendidoValorUnitarioDecimalAnual?.setFocus();
            return false;
        }
        // Validando se o valor unitário do peso pretendido não foi informado quando o lançamento for por peso e a periodicidade pela média mensal
        if (this.isPesoPretendidoValorUnitarioMediaMensalRequired() && (this.entityLancamento.pesoPretendidoValorUnitario == null || this.entityLancamento.pesoPretendidoValorUnitario === undefined)) {
            this.messageService.warning('Informe o preço médio na média mensal ou remova o peso Sell In Cliente e pretendida', 'É obrigatório informar o preço médio na média mensal', notCloseMessageOptions);
            this.pesoPretendidoValorUnitarioDecimalMediaMensal?.setFocus();
            return false;
        }


        // Validando os meses
        for (let i = 0; i < this.entityLancamento.meses?.length; i++) {
            const entityMes = this.entityLancamento.meses[i];
            // Validando se o valor unitário da quantidade pretendida não foi informado quando o lançamento for por quantidade e periodicidade mensal
            if (this.isQuantidadePretendidaValorUnitarioMesRequired(entityMes) && (entityMes.quantidadePretendidaValorUnitario == null || entityMes.quantidadePretendidaValorUnitario === undefined)) {
                this.messageService.warning(`Informe o preço médio no mês de ${this.mesPipe.transform(entityMes.mes)} ou remova a quantidade Sell In Cliente e pretendida`, 'É obrigatório informar o preço médio', notCloseMessageOptions);
                const quantidadePretetendidaValorUnitarioDecimalMes = this.quantidadePretetendidaValorUnitarioDecimalMeses?.find((_, index) => index === i);
                quantidadePretetendidaValorUnitarioDecimalMes?.setFocus();
                return false;
            }

            // Validando se o valor unitário do peso pretendido não foi informado quando o lançamento for por peso e periodicidade mensal
            if (this.isPesoPretendidoValorUnitarioMesRequired(entityMes) && (entityMes.pesoPretendidoValorUnitario == null || entityMes.pesoPretendidoValorUnitario === undefined)) {
                this.messageService.warning(`Informe o preço médio no mês de ${this.mesPipe.transform(entityMes.mes)} ou remova o peso Sell In Cliente e pretendida`, 'É obrigatório informar o preço médio', notCloseMessageOptions);
                const pesoPretendidoValorUnitarioDecimalMes = this.pesoPretendidoValorUnitarioDecimalMeses?.find((_, index) => index === i);
                pesoPretendidoValorUnitarioDecimalMes?.setFocus();
                return false;
            }
        }

        // Sem anotação informada
        if (!this.entityLancamento.anotacao || this.entityLancamento.anotacao.trim().length < 15) {
            // Obrigatória quando não possuir a quantidade pretendida no ano
            if (this.isAnotacaoRequiredSemQuantidadePretendida()) {
                this.messageService.warning('É obrigatório informar uma anotação com pelo menos 15 caracteres informando o motivo do por que deste lançamento não possuir quantidade pretendida', 'É obrigatório informar uma anotação', notCloseMessageOptions);
                jQuery('#anotacao').trigger('focus');
                return false;
            }
            // Obrigatória quando não possuir o peso pretendido no ano
            if (this.isAnotacaoRequiredSemPesoPretendido()) {
                this.messageService.warning('É obrigatório informar uma anotação com pelo menos 15 caracteres informando o motivo do por que deste lançamento não possuir peso pretendido', 'É obrigatório informar uma anotação', notCloseMessageOptions);
                jQuery('#anotacao').trigger('focus');
                return false;
            }
            // Obrigatória quando não possuir o valor pretendido no ano
            if (this.isAnotacaoRequiredSemValorPretendido()) {
                this.messageService.warning('É obrigatório informar uma anotação com pelo menos 15 caracteres informando o motivo do por que deste lancçamento não possuir valor pretendido', 'É obrigatório informar uma anotação', notCloseMessageOptions);
                jQuery('#anotacao').trigger('focus');
                return false;
            }
        }

        // Form inválido
        if (!this.form.valid) {
            this.formsUtilsService.showMsgFormInvalid();
            return false
        }

        return true;
    }

    /** Salva o lançamento da classificação na análise de mercado */
    save(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            if (!this.isValid()) {
                reject();
                return false;
            }

            const entitySave = new ClienteAnaliseMercadoLancamentoSave(this.perspectiva, this.entityLancamento);
            this.clienteAnaliseMercadoLancamentoHttpService.save(entitySave)
                .pipe(
                    take(1)
                )
                .subscribe(
                    response => {
                        this.messageService.success('', response);
                        resolve();
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao salvar o lançamento da análise de mercado', error);
                        reject();
                    }
                );
        });
    }

    /** Realiza o toggle de todos os trimestes */
    toggleTrimestres() {
        this.entityLancamento.trimestresCollapsesShow = !this.entityLancamento.trimestresCollapsesShow;
        this.toggleTrimestre(1, this.entityLancamento.trimestresCollapsesShow);
        this.toggleTrimestre(2, this.entityLancamento.trimestresCollapsesShow);
        this.toggleTrimestre(3, this.entityLancamento.trimestresCollapsesShow);
        this.toggleTrimestre(4, this.entityLancamento.trimestresCollapsesShow);
    }

    /** Realiza o toggle do trimestre informado */
    toggleTrimestre(trimestre: number, collapseShow: boolean) {
        switch (trimestre) {
            case 1:
                if (collapseShow) {
                    jQuery(this.tbodyMensal?.nativeElement).find('.mes.trimestre_1')?.slideUp(0, () => this.entityLancamento.trimestre1CollapseShow = collapseShow);
                } else {
                    jQuery(this.tbodyMensal?.nativeElement).find('.mes.trimestre_1')?.slideDown(0, () => this.entityLancamento.trimestre1CollapseShow = collapseShow);
                }
                break;
            case 2:
                if (collapseShow) {
                    jQuery(this.tbodyMensal?.nativeElement).find('.mes.trimestre_2')?.slideUp(0, () => this.entityLancamento.trimestre2CollapseShow = collapseShow);
                } else {
                    jQuery(this.tbodyMensal?.nativeElement).find('.mes.trimestre_2')?.slideDown(0, () => this.entityLancamento.trimestre2CollapseShow = collapseShow);
                }
                break;
            case 3:
                if (collapseShow) {
                    jQuery(this.tbodyMensal?.nativeElement).find('.mes.trimestre_3')?.slideUp(0, () => this.entityLancamento.trimestre3CollapseShow = collapseShow);
                } else {
                    jQuery(this.tbodyMensal?.nativeElement).find('.mes.trimestre_3')?.slideDown(0, () => this.entityLancamento.trimestre3CollapseShow = collapseShow);
                }
                break;
            case 4:
                if (collapseShow) {
                    jQuery(this.tbodyMensal?.nativeElement).find('.mes.trimestre_4')?.slideUp(0, () => this.entityLancamento.trimestre4CollapseShow = collapseShow);
                } else {
                    jQuery(this.tbodyMensal?.nativeElement).find('.mes.trimestre_4')?.slideDown(0, () => this.entityLancamento.trimestre4CollapseShow = collapseShow);
                }
                break;
            default:
                break;
        }
    }

    ngOnDestroy() {
        this.valorPretendidoAnualSubscription?.unsubscribe();
    }
}
